import { DatePipe } from '@angular/common';
import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BeanQuestion } from './../../../bean/BeanQuestion';
import { JustificationService } from './../cadastro-ficha-monitoria/conteudo-global/justification.service';



import { BeanOperacao } from 'src/bean/BeanOperacao';
import { CadastroUsuarioService } from '../cadastro-usuario/cadastro-usuario.service';
import { ConfiguracaoService } from '../configuracao/configuracao.service';
import { MonitoriaService } from './monitoria.service';


import { CadastroFichaMonitoriaService } from '../cadastro-ficha-monitoria/cadastro-ficha-monitoria.service';
import { ProfileService } from '../cadastro-ficha-monitoria/conteudo-global/profile.service';
import { StatusService } from '../cadastro-ficha-monitoria/conteudo-global/status.service';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BeanUsuario } from 'src/bean/BeanUsuario';
import { BeanMonitoria } from '../../../bean/BeanMonitoria';
import { BeanMonitoryParameter } from '../../../bean/BeanMonitoryParameter';
import { BeanParameter } from '../../../bean/BeanParameter';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';

(pdfMake as any).vfs = (pdfFonts as any).vfs;



import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';

import { BeanFormulario } from 'src/bean/BeanFormulario';
import { BeanPerfil } from 'src/bean/BeanPerfil';
import { BeanStatus } from 'src/bean/BeanStatus';
//import {BeanMonitoria} from '../../../bean/beanUsuario';
import { BeanStatusMonitory } from 'src/bean/BeanStatusMonitory';
import { StatusMonitoryService } from './conteudo-global/status-monitory.service';

import { BeanMonitoryQuestionAnswer } from 'src/bean/BeanMonitoryQuestionAnswer';

import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { BeanJustificativa } from 'src/bean/BeanJustificativa';
import { BeanMonitoryCommentReply } from 'src/bean/BeanMonitoryCommentReply';
import { BeanMonitoryFiles } from 'src/bean/BeanMonitoryFiles';
import { RespostaComentarioDialog } from './dialog-resposta-contestacao/dialog-resposta-contestacao';
import { FeedbackLoginDialogDialog } from './feedback-login-dialog/feedback-login-dialog';
import { ParametroMotivoDialogDialog } from './parametro-motivo-dialog/parametro-motivo-dialog';

import { BeanConfiguracao } from 'src/bean/BeanConfiguracao';
import { BeanContestation } from 'src/bean/BeanContestation';

import { MatStepper } from '@angular/material/stepper';
import { LogsService } from 'src/app/logs/logs.service';
import { BeanCategory } from 'src/bean/BeanCategory';
import { BeanCategoryGroup } from 'src/bean/BeanCategoryGroup';
import { BeanLogs } from 'src/bean/BeanLogs';
import { BeanMotivo } from 'src/bean/BeanMotivo';
import { BeanParametroXMotivo } from 'src/bean/BeanParametroXMotivo';
import { BeanRegularAppraiser } from 'src/bean/BeanRegularAppraiser';
import { BeanRegularAppraiserREQ } from 'src/bean/BeanRegularAppraiserREQ';
import { BeanUtilMoniForm } from 'src/bean/BeanUtilMoniForm';
import { AESEncryptDecryptService } from '../../AESEncryptDecryptService';
import { AnexosDialogComponent } from './anexos-dialog/anexos-dialog.component';
import { ExclusaoMonitoriaDialogComponent } from './exclusao-monitoria-dialog/exclusao-monitoria-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';



const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();



@Component({
  selector: 'app-monitoria',
  templateUrl: './monitoria.component.html',
  styleUrls: ['./monitoria.component.css']
})
export class MonitoriaComponent implements OnInit {

  idUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim());
  tipoUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idTipoUsuario")).trim());
  idEmpresaDoOperador: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idEmpresaDoOperador")).trim());
  idSupervisorDoOperador: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idSupervisorDoOperador")).trim());

  // public lstMonitorias: BeanMonitoria[] = []
  idMonitoriaEdicao: number = 1;
  //dataSource = new MatTableDataSource<BeanMonitoria>(this.lstMonitorias);
  selectedIndex: number = 0;
  breakpoint: number;
  loading: boolean = false;
  isBuscaRe: boolean = false;
  public lstCmbOperacao: BeanOperacao[] = [];
  public lstCmbGestao: BeanUsuario[] = [];
  public lstCmbAssistente: BeanUsuario[] = [];
  public lstStatus: BeanStatus[] = [];
  public lstFormularios: BeanFormulario[] = [];
  public lstMonitorias: BeanMonitoria[] = [];
  public lstMonitoriasRelatorio: BeanMonitoria[] = [];
  public beanMonitoria: BeanMonitoria;
  public beanFormulario: BeanFormulario;

  //public isSpinnerBusca: boolean = false;
  //public isSpinnerCarregarMonitoria: boolean = false;
  //public isSpinnerAddStatus: boolean = false;
  public sessionExpired = false;


  public minDate: Date;
  public maxDate: Date;

  public minDataRelatorio: Date;
  public maxDataRelatorio: Date;

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  public lstBeanStatusMonitory: any;
  public idStatusMonitoriaAdicionado: number = 0

  checkedAtivo = true;
  checkedAtivoRelatorio = true;

  constructor(
    public dialog: MatDialog,
    private cadastroUsuarioService: CadastroUsuarioService,
    private monitoriaService: MonitoriaService,
    private configuracaoService: ConfiguracaoService,
    private toastr: ToastrService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private statusMonitoryService: StatusMonitoryService,
    private statusService: StatusService,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    private cadastroFichaMonitoriaService: CadastroFichaMonitoriaService,
    private formulariomonitoriaDialog: FormulariomonitoriaDialog

  ) {

  }


  ativosInativos: string;


  labelOperacao: string = "";
  labelGestor: string = "";
  labelAssistente: string = "";



  public validaRe() {

    // alert(this.formulario.value.re);

    if (this.formulario.value.re != "" && this.formulario.value.re != null) {
      this.isBuscaRe = true;

      this.formulario.controls['idOperacao'].setValue("");
      this.formulario.controls['idOperacao'].disable();

      this.formulario.controls['idGestor'].setValue("");
      this.formulario.controls['idGestor'].disable();

      this.formulario.controls['idAssistente'].setValue("");
      this.formulario.controls['idAssistente'].disable();

    } else {
      this.isBuscaRe = false
      this.formulario.controls['idOperacao'].enable();
      this.formulario.controls['idGestor'].enable();
      this.formulario.controls['idAssistente'].enable();
    }



  }

  public setDataAte(event): void {

    this.formulario.get('findPeriodoAte').setValue("");
    this.formulario.get('idMonitoriaFind').setValue("");


    const currentYear = new Date().getFullYear();

    //SET PERIODO DE SELEÇÃO DO MINIMO E MÁXMO
    //this.minDate = new Date(currentYear - 0, 0, 0);  // ANOS, MESES, DIAS
    //this.maxDate = new Date(currentYear + 0, 0, 30); // ANOS, MESES, DIAS


    //DATA ATÉ: INICIANDO NA MESMA DATA QUE FOI SELECIONADO NO DE
    const result = new Date(event);
    result.setDate(result.getDate());
    this.minDate = result;


    //DATA ATÉ: FINALIZAR DATA MAXIMA DE 30 DIAS
    const result2 = new Date(event);
    result2.setDate(result2.getDate() + 30); // ADD 30 DIAS
    this.maxDate = result2;

  }

  public limitarDataFim(event): void {

    this.formRelatorio.get('moniDhMonitoriaATE').setValue("");

    //DATA ATÉ: INICIANDO NA MESMA DATA QUE FOI SELECIONADO NO DE
    const result = new Date(event);
    result.setDate(result.getDate());
    this.minDataRelatorio = result;


    //DATA ATÉ: FINALIZAR DATA MAXIMA DE 30 DIAS
    const result2 = new Date(event);
    result2.setDate(31);
    this.maxDataRelatorio = result2;

  }


  ngOnInit(): void {


   


    this.breakpoint = (window.innerWidth >= 800) ? 7 : 2;

    this.ativosInativos = "Ativos";
    this.checkedAtivo = true;
    this.checkedAtivoRelatorio = true;
    this.thirdFormGroup.value.usuarioAtivo = true;
    this.formulario.value.usuarioAtivo = true;
    this.formRelatorio.value.usuarioAtivoRelatorio = true;

    this.InitialFormGroup.controls['consultarOuNovo'].setValue("O");

    this.preencheCmbOperacao().then(
      () => this.preencheListaStatus().then(
        () => this.resetSessionExpired()
      ));


  }

  public sair() {

    this.sessionExpired = false;
    localStorage.clear();
    this.router.navigate([''])

  }

  public setSessionExpired(errorResponse: any): boolean {

    if (errorResponse.status == 401) {

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired() {

    if (this.sessionExpired) {

      this.sair();
      this.toastr.warning("Sua sessão expirou, faça o login novamente!");
    }
  }

  onResize(event) {
    //this.breakpoint = (event.target.innerWidth <= 800) ? 2 : 6;
  }

  public preencheCmbOperacao() {

    return this.cadastroUsuarioService.getUsuarioPorRe(this._AESEncryptDecryptService.decrypt(localStorage.getItem('reUser')).trim()).then((retorno: any) => {

      this.lstCmbOperacao = retorno.operations;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'COMBO OPERACOES');


    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });

  }

  public preencheListaStatus() {

    return this.statusService.listarStatusAtivos().then((lstStatus: BeanStatus[]) => {

      this.lstStatus = lstStatus;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'COMBO STATUS');


    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });
  }




mostrarBtnCriarFicha(event: any){


    if(event.value != null && event.value != '' && event.value != 0)
          document.getElementById("btnCriarFicha").style.visibility = 'visible';


}




  openSnackBar() {


    //ABRIR A MENSAGEM SNACKBAR
    let snack = this._snackBar.open('Este processo irá gerar um ID Monitoria para o assistente selecionado', 'Concordo', {

      duration: 15000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });

    //AÇÃO TOMADA AO CLICAR NO CONCORDADR
    snack.onAction().subscribe(() => {
      this.formulario.value.idOperacao = this.firstFormGroup.value.idOperacao;
      this.formulario.value.idGestor = this.secondFormGroup.value.idGestor;
      this.formulario.value.idAssistente = this.thirdFormGroup.value.idAssistente;

      let newbeanMonitoria: BeanMonitoria = new BeanMonitoria(
        null,
        this.formulario.value.idOperacao,
        Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser')).trim()),
        this.formulario.value.idAssistente,
        this.formulario.value.idGestor,

        null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, [], [], null, [], []
        , null, null);

      //gerar monitoria, preencher this.beanMonitoria e carregar a tela loadMonitoria
      this.gerarNovaMonitoria(newbeanMonitoria).then(() => this.resetSessionExpired());
    });
  }



  public gerarNovaMonitoria(newBeanMonitoria: BeanMonitoria) {

    return this.monitoriaService.addMonitoria(newBeanMonitoria).then((retorno: BeanMonitoria) => {

      this.beanMonitoria = retorno;

      //status criado pelo backend ao criar nova monitoria
      /*this.configuracaoService.getConfiguracaoByChave("grupoconfig.status.inicial").then((retorno:BeanConfiguracao)=>{

              let beanStatusMonitoryInicial : BeanStatusMonitory = new BeanStatusMonitory();

                beanStatusMonitoryInicial.statIdCdStatus = retorno.confDsValString
                beanStatusMonitoryInicial.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria;
                beanStatusMonitoryInicial.usuaIdCdUsuario = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser')).trim();

                //GERAR O STATUS
                this.statusMonitoryService.addStatusMonitory(beanStatusMonitoryInicial, 0).then((retorno:BeanStatusMonitory)=>{
                    this.idStatusMonitoriaAdicionado = Number(beanStatusMonitoryInicial.statIdCdStatus)

                }, errorResponse => {

                  this.setSessionExpired(errorResponse);

                }).catch((retorno:any) => {
                  if(retorno.error.error_description.indexOf("Access token expired")>-1){
                      alert("Sessão Expirada");
                      this.router.navigate(['']);
                    }
                });



      }, errorResponse => {

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','CHAVE CONFIGURACAO');

      }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }

      });*/



      this.listarMonitoriaById(this.beanMonitoria.moniIdCdMonitoria).then(() => this.resetSessionExpired());

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'CRIAR MONITORIA');

    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });
  }

  public preencheFormularios(valorSelecionado: any, tipoFicha: string) {

    if (valorSelecionado != "") {

      this.monitoriaService.listarFormulariosOperacaoFicha(valorSelecionado, tipoFicha).then((retorno: BeanFormulario[]) => {

        this.lstFormularios = retorno;
        this.resetSessionExpired();
      });
    }
  }

  preencheCmbGestao(valorSelecionado: any, menu: number, stepper: MatStepper) {
    this.listarCmbGestao(valorSelecionado.value, menu, stepper).then(() => this.resetSessionExpired());
  }

  public preencheCombos(valorSelecionado: any, menu: number) {

    this.formRelatorio.value.tipoFicha = this.secondFormGroupR.value.tipoFicha;

    this.preencheFormularios(valorSelecionado.value, this.formRelatorio.value.tipoFicha);
    this.preencheCmbGestao(valorSelecionado, menu, null);
  }

  public listarCmbGestao(idOperacao: string, menu: number, stepper: MatStepper) {

    this.labelOperacao = this.lstCmbOperacao.filter(t => t.operIdCdOperacao === idOperacao)[0].operNmOperacao;

    this.clearFormGroup();

    return this.cadastroUsuarioService.listarGestao(idOperacao).then((retorno: BeanUsuario[]) => {

      if (menu == 1) {

        this.lstCmbGestao = retorno;
        this.lstCmbAssistente = [];


        stepper.next();


      } else {

        //supervisor só pode ver os seus operadores
        if (this.tipoUsuarioLogado == 2) {
          this.formulario.controls['idGestor'].setValue(this.idUsuarioLogado);

          this.lstCmbGestao = [];

          for (var i = 0; i < retorno.length; i++) {

            if (Number(retorno[i].usuaIdCdUsuario) == this.idUsuarioLogado) {

              this.lstCmbGestao.push(retorno[i])
              this.listarCmbAssistente(this.formulario.value.idOperacao, retorno[i].usuaIdCdUsuario, this.formulario.value.usuarioAtivo, stepper)

              stepper.next();

              break
            }

          }

        } else {
          this.lstCmbGestao = retorno;

          //corrige prolema de fichas sem o gestor
          this.lstCmbAssistente = [];
          stepper.next();

        }
      }

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'COMBO GESTOR');

    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });
  }


  preencheCmbAssistente(valorSelecionado: any, menu: number, stepper: MatStepper) {

    if (menu == 1) {
      this.formRelatorio.value.operIdCdOperacao = this.firstFormGroupR.value.operIdCdOperacao;
      this.listarCmbAssistente(this.formRelatorio.value.operIdCdOperacao, valorSelecionado.value, this.validarCheckUsuarioAtivoRelatorio(), stepper).then(() => this.resetSessionExpired());

    } else {

      this.formulario.value.idOperacao = this.firstFormGroup.value.idOperacao;
      this.listarCmbAssistente(this.formulario.value.idOperacao, valorSelecionado.value, this.validarCheckUsuarioAtivo(), stepper).then(() => this.resetSessionExpired());
    }
  }


  validarCheckUsuarioAtivo() {

    let isAtivo: boolean = false;

    if (this.thirdFormGroup.value.usuarioAtivo == true || this.thirdFormGroup.value.usuarioAtivo == '') {
      isAtivo = true
      this.formRelatorio.value.usuarioAtivoRelatorio = true;
      this.thirdFormGroup.value.usuarioAtivo = false;
      this.ativosInativos = "Ativos"


    } else {

      this.formRelatorio.value.usuarioAtivoRelatorio = false;
      this.thirdFormGroup.value.usuarioAtivo = false;
      this.ativosInativos = "Inativos"

    }


    return isAtivo;

  }


  validarCheckUsuarioAtivoRelatorio() {

    let isAtivo: boolean = false;

    if (this.fifthFormGroupR.value.usuarioAtivoRelatorio == true) {
      isAtivo = true

      this.fifthFormGroupR.value.usuarioAtivo = true;
      this.ativosInativos = "Ativos"

    } else {

      this.fifthFormGroupR.value.usuarioAtivo = false;
      this.ativosInativos = "Inativos"

    }

    return isAtivo;

  }



  public listarCmbAssistente(idOperacao: string, idGestao: string, isAtivo: boolean, stepper: MatStepper) {


    this.labelGestor = this.lstCmbGestao.filter(t => t.usuaIdCdUsuario === idGestao)[0].usuaNmUsuario;

    return this.monitoriaService.listarAssistente(idOperacao, idGestao, isAtivo).then((retorno: BeanUsuario[]) => {

      this.lstCmbAssistente = retorno;
      stepper.next();

    }, errorResponse => {

      if (!this.setSessionExpired(errorResponse)) {

        this.toastr.info('Não há [Assistente] nesta [Operacao e Gestor], por favor validar o cadastro de usuários.', 'COMBO ASSISTENTE');
        this.lstCmbAssistente = null;
      }

    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });
  }


  public preencheLabelAssistente(valorSelecionado: any, stepper: MatStepper) {

    this.labelAssistente = this.lstCmbAssistente.filter(t => t.usuaIdCdUsuario === valorSelecionado.value)[0].usuaNmUsuario;
    stepper.next();

  }

  onChangeUsuarioAtivo(toggle) {

    this.formulario.value.idGestor = this.secondFormGroup.value.idGestor;

    if (toggle.checked) {
      this.ativosInativos = "Ativos"

      this.checkedAtivo = true;
      this.checkedAtivoRelatorio = true;

      this.formulario.value.usuarioAtivo = true;
      this.formRelatorio.value.usuarioAtivoRelatorio = true;


    } else {
      this.ativosInativos = "Inativos"
      this.checkedAtivo = false;
      this.checkedAtivoRelatorio = false;

      this.formulario.value.usuarioAtivo = false;
      this.formRelatorio.value.usuarioAtivoRelatorio = false;

    }

    if (this.formulario.value.idGestor != "") {
      this.listarCmbAssistente(this.formulario.value.idOperacao, this.formulario.value.idGestor, this.formulario.value.usuarioAtivo, null).then(() => this.resetSessionExpired());
    }


  }



  onChangeUsuarioAtivoRelatorio(toggle) {

    if (toggle.checked) {
      this.ativosInativos = "Ativos"

      this.checkedAtivo = true;
      this.checkedAtivoRelatorio = true;

      this.formulario.value.usuarioAtivo = true;
      this.formRelatorio.value.usuarioAtivoRelatorio = true;


    } else {

      this.checkedAtivo = false;
      this.checkedAtivoRelatorio = false;

      this.ativosInativos = "Inativos"
      this.formulario.value.usuarioAtivo = false;
      this.formRelatorio.value.usuarioAtivoRelatorio = false;

    }

    if (this.formRelatorio.value.usuaIdCdGestor != "") {
      this.listarCmbAssistente(this.formRelatorio.value.operIdCdOperacao, this.formRelatorio.value.usuaIdCdGestor, this.formRelatorio.value.usuarioAtivoRelatorio, null).then(() => this.resetSessionExpired());
    }


  }

  public listarLstMonitoria(idAssistente: string, idStatus: string, dateDe: string, dateAte: string, tipoFicha: string) {

    //this.isSpinnerBusca = true;

    let de = new DatePipe('en').transform(dateDe, 'yyyy-MM-dd HH:mm')
    let ate = new DatePipe('en').transform(dateAte, 'yyyy-MM-dd 23:59')

    return this.monitoriaService.listarMonitoria(idAssistente, idStatus, de, ate, tipoFicha).then((retorno: BeanMonitoria[]) => {

      this.lstMonitorias = [];


      // 1)PEGAR O ULTIMO STATUS EM CADA MONITORIA
      for (let i = 0; i < retorno.length; i++) {

        //coloca na tela o ultimo status para cada monitoria
        retorno[i].statDsStatus = retorno[i].statusMonitory[retorno[i].statusMonitory.length - 1].status.statDsStatus;

        //apenas se o usuario for operador validar se ele já pode ver a ficha
        if (this.tipoUsuarioLogado == 3) {

          this.configuracaoService.getConfiguracaoByChave("grupoconfig.status.liberaroperador").then((retorno2: BeanConfiguracao) => {

            //valida se a mnitoria ja está liberada para visualização do operador
            for (var beanStatusmonitoria of retorno[i].statusMonitory) {

              if (beanStatusmonitoria.statIdCdStatus == retorno2.confDsValString) {

                this.lstMonitorias.push(retorno[i])
                break
              }

            }

            if (this.lstMonitorias.length == 0) {
              this.toastr.info('Não há monitorias para o filtro.', 'LISTAR MONITORIAS');
            }


            //this.isSpinnerBusca = false;
          }, errorResponse => {
            //this.isSpinnerBusca = false;
            this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'COMBO GESTOR');

          }).catch((retorno: any) => {
            //this.isSpinnerBusca = false;
            if (retorno.error.error_description.indexOf("Access token expired") > -1) {
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }

          });

        } else {

          // 1) LISTAR MONITORIAS
          this.lstMonitorias = retorno;

          //this.isSpinnerBusca = false;

        }

      }






    }, errorResponse => {

      if (!this.setSessionExpired(errorResponse)) {

        this.toastr.info('Não há monitorias para o filtro.', 'LISTAR MONITORIAS');
        //this.isSpinnerBusca = false;
        this.lstMonitorias = null;
      }

    }).catch((retorno: any) => {

      //this.isSpinnerBusca = false;
      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });
  }



  public listarMonitoriaById(idMonitoria: string) {

    //this.isSpinnerCarregarMonitoria = true;
    //this.isSpinnerBusca = true;

    return this.monitoriaService.carregaMonitoria(Number(idMonitoria), this.idUsuarioLogado, this.tipoUsuarioLogado)
      .then((retorno: any) => {


        this.beanMonitoria = retorno;
        this.beanMonitoria.moniDsData != null ? this.beanMonitoria.moniDsData.replace(" ", "T") : null;

        //this.clearFormGroup();

        if(this.tipoUsuarioLogado != 3 && retorno.message != null){
          this.toastr.info(retorno.message, 'NÃO ENCONTRADO ')
          return
        }


        if (this.tipoUsuarioLogado == 3 && this.idUsuarioLogado != this.beanMonitoria.usuaIdUsuarioOperador) {
          this.toastr.warning('Você não é o usuário monitorado nesta avaliação.', 'NÃO PERMITIDO')
        } else {
          this.loadDialogFormularioMonitoria();
        }

        //this.isSpinnerCarregarMonitoria = false;
        //this.isSpinnerBusca = false;








      }, errorResponse => {

        if (errorResponse.status == 404) {

          this.toastr.info(errorResponse.error.message);

        } else {

          this.toastr.error('Erro conexao backend\nContate o suporte.', 'CARREGAR MONITORIA');
          //this.isSpinnerBusca = false;
        }

        this.setSessionExpired(errorResponse)

      }).catch((retorno: any) => {

        //this.isSpinnerBusca = false;

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }


      });

  }









  abrirMonitoriaPelaLista(idMonitoria: string) {

    this.listarMonitoriaById(idMonitoria).then(() => this.resetSessionExpired());
  }



  abrirListaConsultaMonitorias() {


    let iduser;

    if (this.tipoUsuarioLogado != 3) {
      this.formulario.value.idMonitoriaFind = this.InitialFormGroup.value.idMonitoriaFind;
      this.formulario.value.idOperacao = this.firstFormGroup.value.idOperacao;
      this.formulario.value.idGestor = this.secondFormGroup.value.idGestor;
      this.formulario.value.idAssistente = this.thirdFormGroup.value.idAssistente;
      this.formulario.value.findPeriodoDe = this.fourthFormGroup.value.findPeriodoDe;
      this.formulario.value.findPeriodoAte = this.fourthFormGroup.value.findPeriodoAte;
      this.formulario.value.idStatus = this.fifthFormGroup.value.idStatus;
      this.formulario.value.re = this.fifthFormGroup.value.re;
      this.formulario.value.tipoFicha = this.fifthFormGroup.value.tipoFicha;

      iduser = this.formulario.value.idAssistente;
    } else {
      iduser = this.idUsuarioLogado;
    }


    let idMonitoria = this.formulario.value.idMonitoriaFind;

    let idOper = this.formulario.value.idOperacao;
    let idGestor = this.formulario.value.idGestor;

    let idStatus = this.formulario.value.idStatus;

    let dataDe = this.formulario.value.findPeriodoDe;
    let dataAte = this.formulario.value.findPeriodoAte;

    let re = this.formulario.value.re;
    let tipoFicha = this.formulario.value.tipoFicha;

    if (re != '' && re > 0) {

      if (dataDe == "" || dataAte == "") {
        this.toastr.error('Favor preencher os campos obrigatórios para consulta, marcados com **', 'VALIDAÇÃO');
        return

      } else {

        this.cadastroUsuarioService.getUsuarioPorRe(re).then((retorno: BeanUsuario) => {

          if (retorno == null) {
            return this.toastr.info('Nenhum usuário encontrado', 'Lista Usuários');
          } else {

          }
          this.listarLstMonitoria(retorno.usuaIdCdUsuario, idStatus, dataDe, dataAte, tipoFicha).then(() => this.resetSessionExpired());

        },
          errorResponse => { //CASO ERRO

            this.setSessionExpired(errorResponse) ? true : this.toastr.info('Nenhum usuário encontrado', 'Lista Usuários');

          }).catch((retorno: any) => {

            if (retorno.error.error_description.indexOf("Access token expired") > -1) {
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
          });
      }

    } else if (idMonitoria.length > 0) {

      this.listarMonitoriaById(idMonitoria).then(() => this.resetSessionExpired());


    }
    else if (this.tipoUsuarioLogado != 3 && (idOper == "" || iduser == "" || dataDe == "" || dataAte == "")) {

      this.toastr.error('Favor preencher os campos obrigatórios para consulta. [Marcados com **]', 'VALIDAÇÃO');
      return


    } else {




      this.listarLstMonitoria(iduser, idStatus, dataDe, dataAte, tipoFicha).then(() => this.resetSessionExpired());

    }



  }

  public InitialFormGroup = new FormGroup({
    consultarOuNovo: new FormControl(""),
    idMonitoriaFind: new FormControl("")
  });

  public firstFormGroup = new FormGroup({
    idOperacao: new FormControl("", Validators.required)
  });

  public secondFormGroup = new FormGroup({
    idGestor: new FormControl("", Validators.required)
  });

  public thirdFormGroup = new FormGroup({
    idAssistente: new FormControl("", Validators.required),
    usuarioAtivo: new FormControl("", Validators.required)
  });

  public fourthFormGroup = new FormGroup({
    findPeriodoDe: new FormControl("", Validators.required),
    findPeriodoAte: new FormControl("", Validators.required)
  });

  public fifthFormGroup = new FormGroup({
    re: new FormControl(""),
    idStatus: new FormControl(""),
    tipoFicha: new FormControl("M"),
    usuarioAtivo: new FormControl("")
  });


  public calendarioPeriodo = new FormGroup({
    inicio: new FormControl(new Date(year, month, 13)),
    fim: new FormControl(new Date(year, month, 16)),
  });

  public formulario: FormGroup = new FormGroup({
    'idOperacao': new FormControl("", Validators.required),
    'idGestor': new FormControl("", Validators.required),
    'idAssistente': new FormControl("", Validators.required),
    'idStatus': new FormControl(""),
    'periodoFind': new FormControl(""),
    'findPeriodoDe': new FormControl("", Validators.required),
    'findPeriodoAte': new FormControl("", Validators.required),
    'idMonitoriaFind': new FormControl(""),
    'usuarioAtivo': new FormControl(""),
    'tipoFicha': new FormControl("M", Validators.required),
    're': new FormControl(""),


  })

  public formRelatorio: FormGroup = new FormGroup({
    'operIdCdOperacao': new FormControl("", Validators.required),
    'formIdCdFormulario': new FormControl("", Validators.required),
    'usuaIdCdGestor': new FormControl(""),
    'usuaIdCdOperador': new FormControl(""),
    'moniDhMonitoriaDE': new FormControl("", Validators.required),
    'moniDhMonitoriaATE': new FormControl("", Validators.required),
    'tipoFicha': new FormControl("M", Validators.required),
    'usuarioAtivoRelatorio': new FormControl(""),
  })

  public firstFormGroupR = new FormGroup({
    operIdCdOperacao: new FormControl("", Validators.required)
  });

  public secondFormGroupR = new FormGroup({
    formIdCdFormulario: new FormControl("", Validators.required),
    tipoFicha: new FormControl("M", Validators.required)
  });

  public thirdFormGroupR = new FormGroup({
    moniDhMonitoriaDE: new FormControl("", Validators.required),
    moniDhMonitoriaATE: new FormControl("", Validators.required),
  });

  public fourthFormGroupR = new FormGroup({
    usuaIdCdGestor: new FormControl("")
  });

  public fifthFormGroupR = new FormGroup({
    usuaIdCdOperador: new FormControl(""),
    usuarioAtivoRelatorio: new FormControl("")
  });

  clearFormGroup() {
    this.secondFormGroup.get('idGestor').setValue("");
    this.thirdFormGroup.get('idAssistente').setValue("");
    this.fifthFormGroup.get('idStatus').setValue("");
    this.formulario.get('idMonitoriaFind').setValue("");
    this.InitialFormGroup.get('idMonitoriaFind').setValue("");

    // this.labelOperacao = "";
    this.labelGestor = "";
    this.labelAssistente = "";

  }


  public add(): void {

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
  }

  loadDialogFormularioMonitoria() {

    const dialogRef = this.dialog.open(FormulariomonitoriaDialog, {
      width: '100vw',
      maxWidth: '100vw'
    });

    dialogRef.componentInstance.beanMonitoria = this.beanMonitoria;
    dialogRef.componentInstance.idStatusMonitoriaAdicionado = this.idStatusMonitoriaAdicionado;


    dialogRef.afterClosed().subscribe(result => {

      this.preencheListaStatus();

      if (result.sessionExpired) {

        this.sessionExpired = result.sessionExpired;
        this.resetSessionExpired();
      }

    });

  }

  buscaMonitorias() {

    this.formRelatorio.value.operIdCdOperacao = this.firstFormGroupR.value.operIdCdOperacao;
    this.formRelatorio.value.formIdCdFormulario = this.secondFormGroupR.value.formIdCdFormulario;
    this.formRelatorio.value.moniDhMonitoriaDE = this.thirdFormGroupR.value.moniDhMonitoriaDE;
    this.formRelatorio.value.moniDhMonitoriaATE = this.thirdFormGroupR.value.moniDhMonitoriaATE;
    this.formRelatorio.value.usuaIdCdGestor = this.fourthFormGroupR.value.usuaIdCdGestor;
    this.formRelatorio.value.usuarioAtivoRelatorio = this.fifthFormGroupR.value.usuarioAtivoRelatorio;
    this.formRelatorio.value.usuaIdCdOperador = this.fifthFormGroupR.value.usuaIdCdOperador;
    this.formRelatorio.value.tipoFicha = this.secondFormGroupR.value.tipoFicha;

    /*
    if(!this.formRelatorio.valid){

      this.toastr.warning("Preencha todos os campos obrigatórios marcados com ** !", "FILTROS OBRIGATÓRIOS");
      return;
    }
    */
    let inicio = new DatePipe('en').transform(this.formRelatorio.value.moniDhMonitoriaDE, 'yyyy-MM-dd HH:mm')
    let fim = new DatePipe('en').transform(this.formRelatorio.value.moniDhMonitoriaATE, 'yyyy-MM-dd 23:59')

    this.monitoriaService.buscarPorFiltros(
      this.formRelatorio.value.operIdCdOperacao,
      this.formRelatorio.value.formIdCdFormulario,
      this.formRelatorio.value.usuaIdCdOperador,
      this.formRelatorio.value.usuaIdCdGestor,
      inicio,
      fim
    ).then((retorno: BeanMonitoria[]) => {

      this.lstMonitorias = retorno;


      //FAZER A IMPRESSÃO DAS FICHAS SELECIONADAS
      if (this.lstMonitorias.length > 0) {

        this.populateLstBeanMoniForm(this.lstMonitorias).then((lstBeanUtilMoniForm: BeanUtilMoniForm[]) => {

          this.formulariomonitoriaDialog.downloadAsPDF('telaRelatorio', lstBeanUtilMoniForm);

        });

      } else {
        this.toastr.info('Não há registros no período.', 'Importar PDF');
      }

      this.resetSessionExpired();

    })
  }



  async populateLstBeanMoniForm(lstMonitoriasRelatorio: any): Promise<BeanUtilMoniForm[]> {

    let lstBeanUtilMoniForm: BeanUtilMoniForm[] = [];

    for (var monitoriasRelatorio of lstMonitoriasRelatorio) {
      //buscar o formulario da monitorias

      await this.cadastroFichaMonitoriaService.lstFormularioPromisse(monitoriasRelatorio.formIdCdFormulario).then((retorno: BeanFormulario) => {
        lstBeanUtilMoniForm.push(new BeanUtilMoniForm(monitoriasRelatorio, retorno))
        this.resetSessionExpired();
      });

    }

    return lstBeanUtilMoniForm;

  }





}

@Component({
  selector: 'formularioMonitoria',
  templateUrl: 'formularioMonitoria.component.html',
  styleUrls: ['./monitoria.component.css']

})

export class FormulariomonitoriaDialog implements OnInit, AfterContentChecked {

  @ViewChild('pdfTable') pdfTable: ElementRef;
  idUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim());
  tipoUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idTipoUsuario")).trim());
  reUsuario: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem('reUser')).trim());
  idUsuario: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser')).trim());

  private textoFechar: string = "Informações não salvas serão perdidas. Deseja fechar a tela?";

  @Input()
  requiredFileType: string;
  fileName = '';
  uploadProgress: number;
  uploadSub: Subscription;
  mogrDsInum = '';
  isValidarRespostaContestada: boolean = false;
  idPerguntaContestacao: number;
  idRespostaContestacao: number;
  bkpIdFormulario: any;
  bkpNrPontuacao: any;
  bkpNrPontuacaoNormal: any;
  bkpNrPontuacaoExtra: any;
  bkpStatIdCdStatus: any;
  bkpIdPerfil: any;
  bkpTxAvaliador: any;
  bkpTxFeedback: any;
  bkpTxAvaliado: any;
  bkpTxAlteracao: any;
  bkpIdJustificativa: any;
  bkpTxJustificativa: any;
  bkpTxObservacao: any;
  bkpDsData: any;
  bkpNrHora: any;

  //Confirmar se realmente deseja sair da tela
  @HostListener('window:keyup.esc') onKeyUp() {

    let dialogTitle = this.textoFechar;
    let dialogText = 'Ação: Sair da tela';
   
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        dialogTitle: dialogTitle,
        dialogText: dialogText
      }, width: '320px'
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
     
      if (result){
        this.dialogRef.close(true);
      }
      
    });
    /*
    let cn = confirm(this.textoFechar)
    if (cn) {
      this.dialogRef.close();
    }
      */
  }
  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {

    event.returnValue = false;
  }


  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<FormulariomonitoriaDialog>,
    private ref: ChangeDetectorRef,
    private cadastroFichaMonitoriaService: CadastroFichaMonitoriaService,
    private profileService: ProfileService,
    private statusService: StatusService,
    private justificationService: JustificationService,
    private configuracaoService: ConfiguracaoService,
    private cadastroUsuarioService: CadastroUsuarioService,
    private toastr: ToastrService,
    private router: Router,
    private statusMonitoryService: StatusMonitoryService,
    private logsService: LogsService,
    private datePipe: DatePipe,
    private monitoriaService: MonitoriaService,
    private http: HttpClient,
    private _AESEncryptDecryptService: AESEncryptDecryptService

  ) { }

  necessarioStatus: boolean = false; // valida se necessita status ao salvar a ficha

  selectedIndex: number = 0;
  public idFormulario: string = "";
  public reEdicao: string = "";
  public nomeEdicao: string = "";

  public beanMonitoria: BeanMonitoria = new BeanMonitoria(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, [], [], null, [], [], null, null);
  public beanFormulario: BeanFormulario = new BeanFormulario(null, null, null, null, null, null, null, null, [], [], [], null);
  public idStatusMonitoriaAdicionado: number = 0;
  public marcadorCabecalhoMotivo: boolean = false;

  public lstCmbFormulario: BeanFormulario[] = []
  public lstCmbPerfil: BeanPerfil[] = []
  public lstRegularAppraiser: BeanRegularAppraiser[] = [];
  public lstCmbStatus: BeanStatus[] = []
  public lstBeanStatusMonitory: BeanStatusMonitory[] = [];
  public beanStatusMonitory: BeanStatusMonitory = new BeanStatusMonitory();
  public lstJustificativa: BeanJustificativa[] = [];

  public formFeedbackDisabled: string = "none";
  public formContentDisabled: string = "none";
  public formIdFormularioDisabled: string = "auto";
  public formStartDisabled: string = "auto";
  public btnSalvarFichaHidden: string = "inline";
  public base64Output: string;
  public beanMonitoryFiles: BeanMonitoryFiles = new BeanMonitoryFiles(null, null, null, null, null);
  //public anexoSpinner: Boolean = false;
  public contemAnexo: Boolean = false;
  public qtdAnexos: number = 0;
  public file: File = null;
  public permParaComentar = false;
  public isReadOnlyFeedback: Boolean = true;
  public alertComentario: Boolean = false;
  public alertContestacao: Boolean = false;
  public isFinalizado: Boolean = false;
  public qtdApontamentoGrave: number = 0;
  public qtdApontamentoNaoGrave: number = 0;

  public perfilDeTempoDeOperacao: string;
  public isLiberarCriarFicha: Boolean = false;

  //public isSpinnerUpdateMonitoria: boolean = false;
  //public isSpinnerAddStatus: boolean = false;
  public sessionExpired: boolean = false;
  tipoLigacao: string;
  tiposLigacao: string[] = ['Inbound', 'Outbound'];
  public beanMonitoryCommentReply: BeanMonitoryCommentReply = new BeanMonitoryCommentReply();

  @ViewChild('idTabelaAdicionarStatus') idTabelaAdicionarStatus: ElementRef;



  public downloadAsPDF(tipo: string, lstMoniForm: BeanUtilMoniForm[]) {

    this.beanMonitoria.moniNrTotalPontos = this.formularioMonitoria.value.nrPontuacao;

    let falhasGraves = 0;
    let htmlColunaPontuacao = " <td style=\"color:blue; font-size:16px;\"> <vazio> </td>";
    let espacos = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"

    let marcadorNovaMonitoria = " <div style=\"background:green; color:green; border: 1px solid green; border-top: 1px solid green;\"> " +
      "OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO&nbsp;&nbsp;&nbsp;" +
      "</div> ";


    //CASO SOLICITE A IMPRESSÃO PDF PELA TELA DE MONITORIA = NULL, CASO SEJA DA TELA DE CONSULTAS POR RANGE VIRÁ PREENCHIDO NA LISTA
    if (lstMoniForm == null && tipo == 'telaMonitoria') {
      let beanFormulario = this.lstCmbFormulario.filter(x => x.formIdCdFormulario == Number(this.beanMonitoria.formIdCdFormulario))[0]
      this.beanMonitoria.forms = beanFormulario;
      lstMoniForm = [(new BeanUtilMoniForm(this.beanMonitoria, this.beanFormulario))];

      //lstMoniForm[0].beanMonitoria.lstRegularAppraiser = this.lstRegularAppraiser;

    }



    //INICIO DO HTML
    var beanTohtml = "<html>" +
      "   <head>" +
      "     <meta charset=\"utf-8\">" +
      "     <title>EasyQualityPDF</title>" +
      "   </head>" +
      " <body style=\"width:100vw\">"




    //MARCADOR VERDE INICIAL
    beanTohtml += marcadorNovaMonitoria;


    //GERAR FICHAS ENVIADAS NA LISTA DO BeanUtilMoniForm[]
    for (let moniForm of lstMoniForm) {

      //**** DADOS DA MONITORIA (Monitoria, avaliador, avaliado, data, pontuação total, etc... )
      beanTohtml += this.fichaPdfDadosDaMonitoria(moniForm, htmlColunaPontuacao)

      beanTohtml += "<table style=\"border:5px solid grey\">"

      beanTohtml += "<tr><td><br/>";

      //***************************/
      //****** MONTAR FICHA *******/
      //***************************/

      //****CABEÇALHO DINAMICO
      beanTohtml = this.fichaPdfDadosCabecalho(beanTohtml, moniForm, espacos)

      //****PERGUNTAS X RESPOSTAS
      beanTohtml = this.fichaPdfPerguntasXRespostas(beanTohtml, moniForm, espacos, tipo, falhasGraves, htmlColunaPontuacao)

      //****COMENTÁRIOS E ENCERRAMENTOS
      beanTohtml = this.fichaPdfComentariosEncerramento(beanTohtml, moniForm, espacos)

      beanTohtml += " </td></tr></table>"

      //marcaador de novamonitoria
      beanTohtml += marcadorNovaMonitoria;

    }

    beanTohtml += " </body>" +
      " </html>"

















    //console.log(beanTohtml)

    //html to pdf format
    var pdfImage = htmlToPdfmake(beanTohtml);
    const documentDefinition = { content: pdfImage };

    var docDefinition = {
      header: function () {/*
            return [
                {
                    style: 'table',
                    margin: [62,35,62,35],
                    table: {
                        widths: ['*', '*'],
                        headerRows: 0,
                        body: [
                            [
                                {text: 'Easy Quality', style: 'topHeader', alignment: 'right'}
                            ]
                        ]
                    },
                    layout: 'noBorders'
                }
            ]
          */},
      footer: function (currentPage, pageCount) {
        return [
          { text: currentPage.toString() + ' de ' + pageCount, alignment: 'center', style: 'footer' }
        ]
      },
      content: pdfImage,
      pageSize: 'A4',
      pageMargins: [10, 5, 10, 15],
      styles: {
        topHeader: {
          fontSize: 8,
          bold: true,
          margin: [0, 0, 0, 0],
          alignment: 'left'
        },
        table: {
          width: '3300px',
          fontSize: 8,
          alignment: 'left',
          color: 'black',
          margin: [20, 5, 20, 15]
        },

        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 15],
          alignment: 'left'
        },
        footer: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
          alignment: 'center'
        }
      }
    };



    //GERA O PDF
    pdfMake.createPdf(docDefinition).open();
    //pdfMake.createPdf(docDefinition).open({}, window);
    //pdfMake.createPdf(docDefinition).print();
    //pdfMake.createPdf(docDefinition).download('EasyQuality_'+fileName+".pdf");

  }




  fichaPdfDadosDaMonitoria(moniForm: BeanUtilMoniForm, htmlColunaPontuacao: string): string {



    let beanTohtml = " 	" +
      " <table id=\"table\" style=\"font-size:10px;margin-left: 0px; margin-right: 05px;\"> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px;font-size:12px;  text-align: right \">MONITORIA:</td></th> " +
      " 	    <th><labe style=\"font-size:12px; \"> <strong>" + moniForm.beanMonitoria.moniIdCdMonitoria + " </strong></td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">EMPRESA:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.operations[0].operNmOperacao + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">AVALIADO:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.userOperador[0].usuaNmUsuario + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">NIVEL DE TEMPO:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.moniDsTempooperacional + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">GESTOR:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.userGestor.usuaNmUsuario + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">INICIO DA MONITORIA:</th> " +
      " 	    <td>" + this.datePipe.transform(new Date(moniForm.beanMonitoria.moniDhRegistro), 'dd/MM/yyyy HH:mm') + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">FORMULÁRIO:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.forms.formDsFormulario + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">TIPO:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.forms.formDsTipoPontuacao + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">PERFIL:</th> " +
      " 	    <td>" + (moniForm.beanMonitoria.profile == null ? '' : moniForm.beanMonitoria.profile[0].perfDsPerfil) + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">AVALIADOR DE PRODUÇÃO:</th> " +
      " 	    <td>" + moniForm.beanMonitoria.userMonitor[0].usuaNmUsuario + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">AVALIADOR REGULAR:</th> "


    try {
      beanTohtml += " 	    <td>" + (moniForm.beanMonitoria.lstRegularAppraiser == null ? '' : moniForm.beanMonitoria.lstRegularAppraiser[0].user.usuaNmUsuario) + "</td> "
    } catch (e) {
      beanTohtml += " 	    <td>&nbsp;</td> "
    }

    beanTohtml += " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\">FEEDBACK ASSINADO:</th> " +
      " 	    <td >" + (moniForm.beanMonitoria.moniDhFeedbackAvaliado == null ? '' : this.datePipe.transform(new Date(moniForm.beanMonitoria.moniDhFeedbackAvaliado), 'dd/MM/yyyy HH:mm')) + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px; text-align: right\"><strong>PONTUAÇÃO FINAL:</strong></th> " +
      htmlColunaPontuacao +
      " 	  </tr> "

    beanTohtml += "  <tr style=\"background:white; color:white; border: 1px solid white; border-top: 1px solid black;\"> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	</tr> "

    " </table> "

    return beanTohtml
  }



  fichaPdfDadosCabecalho(beanTohtml: string, moniForm: BeanUtilMoniForm, espacos: string): string {


    beanTohtml += "<div style=\"font-size:16px; background:grey; color:white; margin-left: 10px;\">" +
      "&nbsp;&nbsp; CABEÇALHO [ " + moniForm.beanMonitoria.moniIdCdMonitoria + " ] " + espacos +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;&nbsp;" +
      "</div>"



    //CABEÇALHO PADRÃO
    beanTohtml += " <table id=\"table\" style=\"font-size:10px;margin-left: 05px; margin-right: 05px; color:black;\"> " +
      " 	<tr> " +
      " 	  <th colspan=\"2\" style=\"text-align : center\">PADRÃO</td> " +
      "   </tr> " +
      " 	<tr> " +
      " 	  <th>Data:</td> " +
      " 	  <td>" + (moniForm.beanMonitoria.moniDsData == null ? '' : this.datePipe.transform(new Date(moniForm.beanMonitoria.moniDsData), "dd/MM/yyyy")) + "</td> " +
      "   </tr> " +
      " 	<tr> " +
      " 	  <th>Hora:</td> " +
      " 	  <td>" + (moniForm.beanMonitoria.moniNrHora == null ? '' : moniForm.beanMonitoria.moniNrHora) + "</td> " +
      "   </tr> " +
      " 	<tr> " +
      " 	  <th>Observação:</td> " +
      " 	  <td>" + (moniForm.beanMonitoria.moniTxObservacao == null ? '' : moniForm.beanMonitoria.moniTxObservacao) + "</td> " +
      "   </tr> " +
      //AJUSTE PARA A TABLE PEGAR O ESPAÇO TODO DE WIDTH
      "   <tr style=\"background:white; color:white; border: 1px solid white; border-top: 1px solid black;\"> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	</tr> " +
      " </table> " +

      " <table id=\"table\" style=\"font-size:10px;margin-left: 05px; margin-right: 05px; color:black;\"> " +
      " 	<tr> " +
      " 	  <th colspan=\"2\" style=\"text-align : center\">ESPECÍFICO DO FORMULÁRIO</td> " +
      "   </tr> "

    //CABEÇALHO DINAMICO
    for (var monitoryParameter of moniForm.beanMonitoria.monitoryParameter) {

      beanTohtml += " 	<tr> " +
        " 	  <th>" + monitoryParameter.parameter.paraDsParametro + "</td> " +
        " 	  <td>" + (monitoryParameter.paraDsValue == null ? '' : monitoryParameter.paraDsValue) + "</td> " +
        " </tr> "
    }

    //AJUSTE PARA A TABLE PEGAR O ESPAÇO TODO DE WIDTH
    beanTohtml += " <tr style=\"background:white; color:white; border: 1px solid white; border-top: 1px solid black;\"> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	</tr> "

    beanTohtml += " </table> ";

    return beanTohtml

  }



  fichaPdfPerguntasXRespostas(beanTohtml: string, moniForm: BeanUtilMoniForm, espacos: string, tipo: string, falhasGraves: number, htmlColunaPontuacao: string): string {

    beanTohtml += "<div style=\"font-size:16px; background:grey; color:white; margin-left: 10px; \">&nbsp;&nbsp; PERGUNTAS E RESPOSTAS [ " + moniForm.beanMonitoria.moniIdCdMonitoria + " ]" +
      espacos + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;" +
      "</div>"

    for (var i = 0; i < moniForm.beanFormulario.categoryGroups.length; i++) {

      let idGrupoCategoria = moniForm.beanFormulario.categoryGroups[i].grcaIdCdGrupoCategoria;
      let grupoCategoria = moniForm.beanFormulario.categoryGroups[i].grcaDsGrupoCategoria;
      let grcaMapeamento = moniForm.beanFormulario.categoryGroups[i].grcaInMapeamento;

      for (var j = 0; j < moniForm.beanFormulario.categoryGroups[i].categories.length; j++) {

        let idCategoria = moniForm.beanFormulario.categoryGroups[i].categories[j].cateIdCdCategoria;
        let categoria = moniForm.beanFormulario.categoryGroups[i].categories[j].cateDsCategoria;
        let divGrcaMapeamento = "";

        if (grcaMapeamento != "N") {
          divGrcaMapeamento = "<strong>| <span style=\"color: DarkOrange;\">M</span> | </strong>";
        }

        //*** GRUPO E CATEGORIA */
        beanTohtml += " 	<table id=\"table\" style=\"font-size:10px;margin-left: 5px; margin-right: 05px; color:black;\"> " +
          " 	  <tr> " +
          " 	    <td style=\"display: flex; width:250px; text-align: left; font-size:14px; color:black; border: 1px solid white; border-bottom: 1px solid black; border-right: 1px solid black;\">" +
          "         &#8226; " +
          divGrcaMapeamento + "<strong>" + grupoCategoria + " - " + categoria + "</strong>" +
          "       </td> " +
          " 	    <th style=\"width:100px; font-size:12px;\">Resposta</th> " +
          " 	    <th style=\"width:100px; font-size:12px;\">Pontuação</th> " +
          " 	  </tr> "

        for (var k = 0; k < moniForm.beanMonitoria.monitoryQuestionAnswers.length; k++) {

          if (idGrupoCategoria == moniForm.beanMonitoria.monitoryQuestionAnswers[k].grcaIdCdGrupoCategoria
            && idCategoria == moniForm.beanMonitoria.monitoryQuestionAnswers[k].cateIdCdCategoria) {


            if (moniForm.beanMonitoria.monitoryQuestionAnswers[k].question.pergDhInativo != null) {
              //pergunta inativa fazer algo?

              //console.log(moniForm.beanMonitoria.monitoryQuestionAnswers[k].question)
            } else {

              let pergunta = moniForm.beanMonitoria.monitoryQuestionAnswers[k].question.pergDsPergunta;


              if (pergunta.indexOf('A OPERAÇÃO REALIZA COLETA DE ORIGEM RACIAL OU ÉTNICA?') > -1) {
                console.log('teste')
              }
              let comentario = "";

              let isTrunfo = moniForm.beanMonitoria.monitoryQuestionAnswers[k].question.pergInExtra;
              let htmlTrunfo = "";

              if (isTrunfo == "S") {
                htmlTrunfo = "<strong>| <span style=\"color: DarkOrange;\">T</span> |  </strong>";
              } else {
                htmlTrunfo = "&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;";
              }


              beanTohtml += " 	<tr> " ;



              for (var m = 0; m < moniForm.beanFormulario.categoryGroups[i].categories[j].questions.length; m++) {
                
                let idPerguntamonitoria = moniForm.beanMonitoria.monitoryQuestionAnswers[k].question.pergIdCdPergunta;
                let cadadstroPergunta = moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].pergIdCdPergunta;

                if (idPerguntamonitoria == cadadstroPergunta) {

                
                  if (moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].questionAnswers.length == 0) {
                        //Remove a questão que está no índice m
                       moniForm.beanFormulario.categoryGroups[i].categories[j].questions.splice(m, 1);
                       
                    //beanTohtml += " <td> [ RETIRADO VINCULO ] </td> " +
                      //" <th style=\"font-size:12px; color:blue; text-align:center\">&nbsp;</th> "
                  } else {
                    //*** MONTAR PERGUNTA */
                    beanTohtml += " 	  <td>" + htmlTrunfo + pergunta + "</td> "
                  for (var n = 0; n < moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].questionAnswers.length; n++) {


                      //QUANDO A PERGUNTA EXISTE NA PERM E NÃO EXISTI MAIS VINCULOS NA TABELA DE CADASTRO (** NÃO DÁ PRA SABER QUAL FOI A NOTA DA RESPOSTA POIS A MESMA SE ENCONTRA NA TABELA DE CADASTRO PERE)
                      if (moniForm.beanMonitoria.monitoryQuestionAnswers[k].answer != null) {


                        if (moniForm.beanMonitoria.monitoryQuestionAnswers[k].answer.respIdCdResposta == moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].questionAnswers[n].respIdCdResposta) {


                          let pontos = moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].questionAnswers[n].pereNrPonto;
                          if (pontos == null) {
                            pontos = moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].questionAnswers[n].pereNrPontoExtra;
                          }

                          let zerarMonitoria = moniForm.beanFormulario.categoryGroups[i].categories[j].questions[m].questionAnswers[n].pereInZerar;


                          if (tipo == 'telaMonitoria') {
                            const COMMENT = moniForm.beanMonitoria.comment.find(
                              comment =>
                                comment.pergIdCdPergunta == moniForm.beanMonitoria.monitoryQuestionAnswers[k].pergIdCdPergunta
                                && comment.respIdCdResposta == moniForm.beanMonitoria.monitoryQuestionAnswers[k].respIdCdResposta
                                && comment.cateIdCdCategoria == moniForm.beanMonitoria.monitoryQuestionAnswers[k].cateIdCdCategoria
                                && comment.grcaIdCdGrupoCategoria == moniForm.beanMonitoria.monitoryQuestionAnswers[k].grcaIdCdGrupoCategoria);

                            comentario = COMMENT != undefined ? COMMENT.recmTxComentario : "";
                          } else {

                            let comment = moniForm.beanMonitoria.comment.filter(t => t.grcaIdCdGrupoCategoria === idGrupoCategoria
                              && t.cateIdCdCategoria === idCategoria
                              && t.pergIdCdPergunta === idPerguntamonitoria
                              && t.respIdCdResposta === moniForm.beanMonitoria.monitoryQuestionAnswers[k].answer.respIdCdResposta)[0];

                            if (comment != undefined && comment != null) {
                              comentario = comment.recmTxComentario;
                            }
                          }

                          let respNaoSeAplica = moniForm.beanMonitoria.monitoryQuestionAnswers[k].answer.respInNaoseaplica;
                          let htmlRespNaoSeAplica = "";

                          if (respNaoSeAplica == "S") {
                            htmlRespNaoSeAplica = "<strong>| <span style=\"color: DarkOrange;\">NA</span> |  </strong>";
                          }

                          //*** MONTAR RESPOSTA */
                          beanTohtml += " 	  <td>" + (moniForm.beanMonitoria.monitoryQuestionAnswers[k].answer == null ? '' : htmlRespNaoSeAplica + moniForm.beanMonitoria.monitoryQuestionAnswers[k].answer.respDsResposta) + "</td> "


                          //*** MONTAR PONTUAÇÃO */
                          if (zerarMonitoria == 'S') {

                            beanTohtml += " <th style=\"font-size:12px; color:red; text-align:center\"> XX </th> "

                            falhasGraves++;


                          } else if (zerarMonitoria != 'S' && Number(pontos) < 10) {

                            if (comentario != "" && comentario != null) {
                              beanTohtml += " <th style=\"font-size:12px; color:#666600; text-align:center\"> 0" + pontos + " </th> "
                            } else {
                              beanTohtml += " <th style=\"font-size:12px; color:blue; text-align:center\"> 0" + pontos + " </th> "
                            }
                          } else {

                            if (comentario != "" && comentario != null) {
                              beanTohtml += " <th style=\"font-size:12px; color:#666600; text-align:center\"> " + pontos + " </th> "
                            } else {
                              beanTohtml += " <th style=\"font-size:12px; color:blue; text-align:center\"> " + pontos + " </th> "
                            }

                          }

                        }

                      } else {

                        beanTohtml += " <td style=\"font-size:12px; color:blue;\">&nbsp;</td> " +
                          " <th style=\"font-size:12px; color:blue; text-align:center\">**</th> "

                        break;

                      }

                    }

                  }
                }
              }

              beanTohtml += " </tr> "


              //*** MONTAR VOMENTARIO CASO HOUVER */
              if (comentario != "" && comentario != null) {

                beanTohtml += "<tr>" +
                  "<th style=\"font-size:12px; color:#666600; text-align:left;\" colspan=\"3\">**Comentário: " + comentario + "</th>" +
                  "</tr>"

              }


            }
          }

        }

        //AJUSTE PARA A TABLE PEGAR O ESPAÇO TODO DE WIDTH
        beanTohtml += " <tr style=\"background:white; color:white; border: 1px solid white; border-top: 1px solid black;\"> " +
          " 	  <td>OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO</td> " +
          " 	  <td>OOOOOOOOOOOOOOOO</td> " +
          " 	  <td>OOOOOOOOO</td> " +
          " 	</tr> "

        beanTohtml += " </table> "

      }

    }

    beanTohtml += "<span style=\"color: red; font-size: 11px; font-weight: bold;\">* Observações do questionário: </span>" +
      "<p style=\"font-size: 11px;\">| <span style=\"color: DarkOrange;\">M</span> | - Grupo de monitoria mapeamento (não acrescenta valor a nota final)." +
      "<br>| <span style=\"color: DarkOrange;\">T</span> | - Pergunta que acrescenta uma soma de pontos ao valor final da média." +
      "<br>| <span style=\"color: DarkOrange;\">NA</span> | - Tipo de resposta que desconsidera a pergunta no cauculo de média. </p>";

    //***************************/
    //****** TRATAR FICHA *******/
    //***************************/

    //VALIDA E PREENCHE FALHAS GRAVES OU PONTUAÇÃO COM CORES DIFERENTES
    if (falhasGraves > 0) {
      beanTohtml = beanTohtml.replace(htmlColunaPontuacao, "<td style=\"color: red; font-size:16px;\"><strong> 00 </strong> <i> ( Não conformidade(s) grave(s) : " + falhasGraves + " )</i> </td>")

    } else if (falhasGraves == 0 && Number(moniForm.beanMonitoria.moniNrTotalPontos) > 94) {
      beanTohtml = beanTohtml.replace(htmlColunaPontuacao, "<td style=\"color: blue; font-size:16px;\"><strong> " + moniForm.beanMonitoria.moniNrTotalPontos + " </strong> </td>")

    } else {
      beanTohtml = beanTohtml.replace(htmlColunaPontuacao, "<td style=\"color: #666600; font-size:16px;\"><strong> " + moniForm.beanMonitoria.moniNrTotalPontos + " </strong> </td>")

    }

    return beanTohtml;
  }



  fichaPdfComentariosEncerramento(beanTohtml: string, moniForm: BeanUtilMoniForm, espacos: string): string {

    beanTohtml += "<div style=\"font-size:16px; background:grey; color:white; margin-left: 10px; \">&nbsp;&nbsp; COMENTÁRIOS E ENCERRAMENTO [ " + moniForm.beanMonitoria.moniIdCdMonitoria + " ]" +
      espacos + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;" +
      "</div>" +

      " <table id=\"table\" style=\"font-size:10px;margin-left: 05px; margin-right: 05px; color:black;\"> " +

      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px;\">Avaliador:</th> " +
      " 	    <td>" + (moniForm.beanMonitoria.moniTxAvaliador == null ? '' : moniForm.beanMonitoria.moniTxAvaliador) + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px;\">Feedback:</th> " +
      " 	    <td>" + (moniForm.beanMonitoria.moniTxFeedback == null ? '' : moniForm.beanMonitoria.moniTxFeedback) + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px;\">Alterações:</th> " +
      " 	    <td>" + (moniForm.beanMonitoria.moniTxAlteracao == null ? '' : moniForm.beanMonitoria.moniTxAlteracao) + "</td> " +
      " 	  </tr> " +
      " 	  <tr> " +
      " 	    <th style=\"width:300px; font-size:12px;\">Justificativas:</th> " +
      " 	    <td>" + (moniForm.beanMonitoria.moniTxJustificativa == null ? '' : moniForm.beanMonitoria.moniTxJustificativa) + "</td> " +
      " 	  </tr> "

    //AJUSTE PARA A TABLE PEGAR O ESPAÇO TODO DE WIDTH
    beanTohtml += " <tr style=\"background:white; color:white; border: 1px solid white; border-top: 1px solid black;\"> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOO</td> " +
      " 	  <td>OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO</td> " +
      " 	</tr> "

    beanTohtml += " </table> ";

    console.log(beanTohtml);
    return beanTohtml

  }




  ngAfterContentChecked() {

    this.resetSessionExpired();
  }

  public setSessionExpired(errorResponse: any) {

    if (errorResponse.status == 401) {

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired() {

    if (this.sessionExpired) {

      this.sessionExpired = false;

      setTimeout(() => this.dialogRef.close({ sessionExpired: true }));
    }
  }


  ngOnInit(): void {

    
    //this.isSpinnerUpdateMonitoria = true;

    this.getQtdApontamentosZeradosGrave(Number(this.beanMonitoria.moniIdCdMonitoria));


    //validar se o formulario já foi selecionado para a monitoria
    if (this.beanMonitoria.formIdCdFormulario != null && this.beanMonitoria.formIdCdFormulario != '' && this.beanMonitoria.formIdCdFormulario != '0') {

      this.listarTodasFichasPorOperacao(this.beanMonitoria.operIdCdOperacao);

      //this.formIdFormularioDisabled = "none"; // BLOQUEAR CAMPO FORMULARIO

      if (this.beanMonitoria.justIdCdJustificativa == "1") {
        this.desabilitarTudo();
      } else {
        this.formContentDisabled = "auto"; // HABLILITAR O RESTANTE DO FORMULARIO
      }

      this.formularioMonitoria.controls['idFormulario'].setValue(this.beanMonitoria.formIdCdFormulario);

      this.onChangeMontarFormulario();
      this.getQtdApontamentosZeradosNaoGrave(Number(this.beanMonitoria.moniIdCdMonitoria));

      this.mogrDsInum = this.beanMonitoria.recording.length > 0 ? this.beanMonitoria.recording[0].mogrDsInum : "";





    } else {

      this.listarFichasPorOperacao(this.beanMonitoria.operIdCdOperacao);

    }




    this.listarPerfil();
    this.listarStatusAtivo();
    this.listarJustificativasAtivas();
    this.permissaoParaComentar();
    this.preencheLstRegularAppraiser();

    //adicionar get do anexo
    this.buscarAnexoMonitoria();

    if (this.beanMonitoria.moniDsTempooperacional != null && this.beanMonitoria.moniDsTempooperacional != '') {
      this.perfilDeTempoDeOperacao = this.beanMonitoria.moniDsTempooperacional;
    } else {
      this.getPerfilTempoOperacao();
    }


    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(_ => {

      let dialogTitle = this.textoFechar;
      let dialogText = 'Ação: Sair da tela';
    
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          dialogTitle: dialogTitle,
          dialogText: dialogText
        }, width: '320px'
      });

      dialogRef.afterClosed().subscribe((result: boolean) => {
      
        if (result){
          this.dialogRef.close(true);
        }
        
      });
      
      /*
      let cn = confirm(this.textoFechar)
      if (cn) {
        this.dialogRef.close();
      }*/

    })


    //CASO FEEDBACK ESTEJA ASSINADO E O USUARIO FOR OPERADOR BLOQUEAR TODOS OS CAMPOS
    if (this.formularioMonitoria.value.txFeedback != "" && this.formularioMonitoria.value.txFeedback != null) {
      this.desabilitarTudo();

    } else {


      if (this.tipoUsuarioLogado == 3 && (Number(this.beanMonitoria.userOperador[0].usuaIdCdUsuario ) == this.idUsuarioLogado)){


         this.formIdFormularioDisabled = "none"; // BLOQUEAR CAMPO FORMULARIO
            this.formContentDisabled = "none"; // BLOQUEAR O RESTANTE DO FORMULARIO
            this.formFeedbackDisabled = "auto"; // LIBERAR O CAMPO DE APLICAR FEEDBACK

            

      }else if(this.tipoUsuarioLogado != 3 || (Number(this.beanMonitoria.userMonitor[0].usuaIdCdUsuario) != this.idUsuarioLogado)) {
            
        if(this.tipoUsuarioLogado != this.beanMonitoria.userMonitor[0].tiusIdCdTipoUsuario){
          this.formIdFormularioDisabled = "none"; // BLOQUEAR CAMPO FORMULARIO
          this.formContentDisabled = "none"; // BLOQUEAR O RESTANTE DO FORMULARIO
          this.formFeedbackDisabled = "none"; // BLOQUEAR O RESTANTE DO FORMULARIO
        }else{
            this.formIdFormularioDisabled = "auto"; // LIBERAR CAMPO FORMULARIO
            this.formContentDisabled = "auto"; // LIBERAR O RESTANTE DO FORMULARIO
            this.formFeedbackDisabled = "auto"; // LIBERAR O CAMPO DE APLICAR FEEDBACK
            
          }
      }else{
          this.formIdFormularioDisabled = "none"; // BLOQUEAR CAMPO FORMULARIO
          this.formContentDisabled = "none"; // BLOQUEAR O RESTANTE DO FORMULARIO
      }
      /*
      //Se o tipo do usuário logado for diferente do usuario monitor (que abriu a monitoria) bloquear formulario
      if(this.tipoUsuarioLogado != this.beanMonitoria.userMonitor[0].tiusIdCdTipoUsuario){
          this.formIdFormularioDisabled = "none"; // BLOQUEAR CAMPO FORMULARIO
          this.formContentDisabled = "none"; // BLOQUEAR O RESTANTE DO FORMULARIO
      }*/

    }
    //this.isSpinnerUpdateMonitoria = false;



    this.bkpIdFormulario =  this.formularioMonitoria.value.idFormulario
    this.bkpNrPontuacao =  this.formularioMonitoria.value.nrPontuacao
    this.bkpNrPontuacaoNormal =  this.formularioMonitoria.value.nrPontuacaoNormal
    this.bkpNrPontuacaoExtra =  this.formularioMonitoria.value.nrPontuacaoExtra
    this.bkpStatIdCdStatus =  this.formularioMonitoria.value.statIdCdStatus
    this.bkpIdPerfil =  this.formularioMonitoria.value.idPerfil
    this.bkpTxAvaliador =  this.formularioMonitoria.value.txAvaliador
    this.bkpTxFeedback =  this.formularioMonitoria.value.txFeedback
    this.bkpTxAvaliado =  this.formularioMonitoria.value.txAvaliado
    this.bkpTxAlteracao =  this.formularioMonitoria.value.txAlteracao
    this.bkpIdJustificativa=  this.formularioMonitoria.value.idJustificativa
    this.bkpTxJustificativa =  this.formularioMonitoria.value.txJustificativa
    this.bkpTxObservacao=  this.formularioMonitoria.value.txObservacao
    this.bkpDsData =  this.formularioMonitoria.value.dsData
    this.bkpNrHora =  this.formularioMonitoria.value.nrHora


  }


  atualizarDetalhesAgrupadores(idMonitoria: number) {


    return this.monitoriaService.carregarPontosPorAgrupador(idMonitoria)
      .then((retorno: any) => {



        for (var bean of retorno) {

          let formIndexGrca = this.beanFormulario.categoryGroups.findIndex(x => x.grcaIdCdGrupoCategoria === bean.grca_id_cd_grupocategoria);
          let formIndexCate = this.beanFormulario.categoryGroups[formIndexGrca].categories.findIndex(x => x.cateIdCdCategoria === bean.cate_id_cd_categoria);

          this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].points = bean.pontos;
          this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].possuiComentario = bean.possuiComentario;
          this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].possuiContestacao = bean.possuiContestacao;

        }




      }, errorResponse => {

        if (errorResponse.status == 404) {

          this.toastr.info(errorResponse.error.message);

        } else {

          this.toastr.error('Erro conexao backend\nContate o suporte.', 'CARREGAR MONITORIA');
          //this.isSpinnerBusca = false;
        }

        this.setSessionExpired(errorResponse)

      }).catch((retorno: any) => {

        //this.isSpinnerBusca = false;

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }


      });

  }




  //insere tipo dpo usuario[BABY] [NOVATO] OU [VETERANO]
  getPerfilTempoOperacao() {

    this.monitoriaService.buscarConfiguracaoTempoDeOperacao(2).then((retorno: BeanConfiguracao[]) => {

      this.monitoriaService.buscarTempoUsuarioOperacao(this.beanMonitoria.userOperador[0].usuaDhInicioOperacional).then((qtdDias: number) => {

        for (let i = 0; i < retorno.length; i++) {

          let array = retorno[i].confDsValString.split(";")
          let qtdDiasDe = Number(array[0])
          let qtdDiasAte = Number(array[1])

          if (qtdDias >= qtdDiasDe && qtdDias <= qtdDiasAte) {

            let configuracao = retorno[i].confDsConfiguracao;

            this.perfilDeTempoDeOperacao = configuracao.substring(configuracao.indexOf("[") + 1, configuracao.indexOf("]"))
            break;
          }


        }


        // BABY / NOVATO / VETERANO
        if (this.perfilDeTempoDeOperacao == undefined || this.perfilDeTempoDeOperacao == '') {
          let confTempoMaximo = retorno.filter(beanConf => beanConf.confDsValString.indexOf('~') > -1)[0]

          this.perfilDeTempoDeOperacao = confTempoMaximo.confDsConfiguracao.substring(confTempoMaximo.confDsConfiguracao.indexOf("[") + 1, confTempoMaximo.confDsConfiguracao.indexOf("]"))
        }





      },
        errorResponse => { //CASO ERRO
          this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.', 'Lista Usuários');

        }).catch((retorno: any) => {

          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
        });

    },
      errorResponse => { //CASO ERRO

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.', 'Lista Usuários')

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });


  }


  desabilitarTudo() {
    this.formIdFormularioDisabled = "none"; // BLOQUEAR CAMPO FORMULARIO
    this.formContentDisabled = "none"; // BLOQUEAR O RESTANTE DO FORMULARIO
    this.isFinalizado = true;

  }



  ngAfterViewInit() {
  }

  public formularioMonitoria: FormGroup = new FormGroup({
    'idFormulario': new FormControl(""),
    'nrPontuacao': new FormControl(""),
    'nrPontuacaoNormal': new FormControl(""),
    'nrPontuacaoExtra': new FormControl(""),
    'statIdCdStatus': new FormControl(""),
    'idPerfil': new FormControl(""),
    'txAvaliador': new FormControl(""),
    'txFeedback': new FormControl(""),
    'txAvaliado': new FormControl(""),
    'txAlteracao': new FormControl(""),
    'idJustificativa': new FormControl(""),
    'txJustificativa': new FormControl(""),
    'txObservacao': new FormControl(""),
    'dsData': new FormControl(""),
    'nrHora': new FormControl("")

  })


  public alertValidacao(campo: string) {


    if (['txAvaliador', 'txAvaliado', 'txAlteracao', 'idJustificativa', 'txJustificativa'].includes(campo)) { //VALIDA SE O campo É UM DOS ELEMENTOS tx... DA CONDIÇÃO
      if (this.idUsuario == Number(this.beanMonitoria.usuaIdCdUsuarioMonitor)) {
          this.toastr.warning('Apenas o avaliaddor desta monitoria poderá inserir este registro', 'VALIDAÇÃO')
        }
    }

  }

  // ADICIONANDO METODOS PARA CONTROLAR O UPLOAD DE ARQUIVO


  public sair(texto?: string): void {
  
    let dialogTitle = texto != undefined ? texto : 'Confirma o fechamento da tela de ficha?';
    let dialogText = 'Ação: Sair da ficha';
   
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        dialogTitle: dialogTitle,
        dialogText: dialogText
      }, width: '320px'
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
     
      if (result){
        this.dialogRef.close(true);
      }
      
    });


  }

  onFileSelected(event, fileUpload) {

    //this.anexoSpinner = true;
    this.file = event.target.files[0];

    if (this.file) {

      this.fileName = this.file.name;

      this.convertFile(this.file).subscribe(base64 => {
        this.beanMonitoryFiles.moanDsArquivo = base64
        this.beanMonitoryFiles.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria
        this.beanMonitoryFiles.moanDsNomeArquivo = this.file.name
        this.base64Output = base64;
        this.monitoriaService.addAnexo(this.beanMonitoryFiles).then((ret: any) => {
          this.toastr.success('Arquivo gravado com sucesso!', 'Anexar Arquivo')
          //this.anexoSpinner = false;
          this.contemAnexo = true;
          this.beanMonitoryFiles.moanIdCdMonitoriaAnexo = ret.moanIdCdMonitoriaAnexo
          fileUpload.value = ''
        },
          errorResponse => { //CASO ERRO

            this.setSessionExpired(errorResponse);
            //this.anexoSpinner = false;

          }).catch((retorno: any) => {

            this.toastr.error(retorno.error.error_description, 'ERRO!')
            //this.anexoSpinner = false;


          });


      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      });

    }
  }
  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }


  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }

  buscarAnexoMonitoria() {
    this.monitoriaService.buscarAnexo(this.beanMonitoria.moniIdCdMonitoria)
      .then((ret) => {
        if (ret.length > 0) {
          this.qtdAnexos = ret.length
          this.contemAnexo = true
          this.fileName = ret[0].moanDsNomeArquivo
          this.beanMonitoryFiles.moanDsNomeArquivo = this.fileName
          this.beanMonitoryFiles.moanIdCdMonitoriaAnexo = ret[0].moanIdCdMonitoriaAnexo
          this.beanMonitoryFiles.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria
        }

      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })
  }

  downloadAnexo() {
    //this.anexoSpinner = true
    this.monitoriaService.downloadAnexo(this.beanMonitoryFiles.moanIdCdMonitoriaAnexo)
      .then((ret) => {

        const downloadLink = document.createElement('a');


        downloadLink.href = 'data:application/octet-stream;base64,' + ret.moanDsArquivo;
        downloadLink.download = ret.moanDsNomeArquivo;
        downloadLink.click();
        //this.anexoSpinner = false
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })

  }

  deletarAnexo() {
    //this.anexoSpinner = true
    this.monitoriaService.deletarAnexo(this.beanMonitoryFiles.moanIdCdMonitoriaAnexo)
      .subscribe((data: any) => {
        this.toastr.success('Arquivo excluido com sucesso!')
        //this.anexoSpinner = false
        this.contemAnexo = false
        this.fileName = ''
        this.file = null
        this.beanMonitoryFiles.moanDsArquivo = null
        this.beanMonitoryFiles.moniIdCdMonitoria = null
        this.beanMonitoryFiles.moanDsNomeArquivo = null
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })

  }


  loadDialogAnexo() {

    const dialogRef = this.dialog.open(AnexosDialogComponent, {
      width: '55%',
      data: {
        idMonitoria: this.beanMonitoria.moniIdCdMonitoria,
        isFinalizado: this.isFinalizado
      }

    });



    dialogRef.afterClosed().subscribe(result => {

      if (result.sessionExpired) {

        this.sessionExpired = result.sessionExpired;
        this.resetSessionExpired();

      } else {
        this.buscarAnexoMonitoria()

        if(result.adicionouAnexo == true ){
          this.necessarioStatus = true;
        }

      }

    });

  }



  // ADICIONANDO METODOS PARA CONTROLAR O UPLOAD DE ARQUIVO
  //dataSourceFicha = new MatTableDataSource<BeanUsuario>(this.lstUsuarios);
  displayedColumnsBusca: string[] = ['fichaMonitoria', 'inativoFicha'];

  public listarFichasPorOperacao(idOperacao: string) {

    this.cadastroFichaMonitoriaService.listaFormulariosPorOperacoes(idOperacao, 'ativo').subscribe(retorno => {

      this.lstCmbFormulario = retorno;


    },
      errorResponse => { //CASO ERRO

        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há formulários disponíveis para a operação selecionada', 'Lista Formulários');

      });
  }

  public listarTodasFichasPorOperacao(idOperacao: string) {

    this.cadastroFichaMonitoriaService.listaTodosFormulariosPorOperacoes(idOperacao).subscribe(retorno => {

      this.lstCmbFormulario = retorno;


    },
      errorResponse => { //CASO ERRO

        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há formulários disponíveis para a operação selecionada', 'Lista Formulários');

      });
  }





  openColapseQuestions(obj: any, categoryGroup: BeanCategory, idCategoria: number) {

    //CArregar somente se o item for expandido (aberto) e ao fechar não fazer nada
    if (obj.srcElement.ariaExpanded == 'false') {

      let modelGrupoCategoria = this.beanFormulario.categoryGroups.filter(x => x.grcaIdCdGrupoCategoria == categoryGroup.grcaIdCdGrupoCategoria)

      this.validaPerguntasDefaultColapse(modelGrupoCategoria, idCategoria);
      this.validaPerguntaComentadaColapse(modelGrupoCategoria, idCategoria);
      //this.validaPerguntaComentada();
    }



  }





  preencheCamposDaTelaMonitoria(beanMonitoria: BeanMonitoria) {
    //this.formularioMonitoria.controls['idFormulario'].setValue(beanMonitoria.forms[0].formIdCdFormulario);
    this.formularioMonitoria.controls['idPerfil'].setValue(beanMonitoria.perfIdCdPerfil);
    this.formularioMonitoria.controls['txAvaliador'].setValue(beanMonitoria.moniTxAvaliador);
    this.formularioMonitoria.controls['nrPontuacao'].setValue(beanMonitoria.moniNrTotalPontos);
    this.formularioMonitoria.controls['txFeedback'].setValue(beanMonitoria.moniTxFeedback);
    this.formularioMonitoria.controls['txAvaliado'].setValue(beanMonitoria.moniTxAvaliado);
    this.formularioMonitoria.controls['txAlteracao'].setValue(beanMonitoria.moniTxAlteracao);
    this.formularioMonitoria.controls['idJustificativa'].setValue(beanMonitoria.justIdCdJustificativa);
    this.formularioMonitoria.controls['txJustificativa'].setValue(beanMonitoria.moniTxJustificativa);
    this.formularioMonitoria.controls['txObservacao'].setValue(beanMonitoria.moniTxObservacao);
    this.formularioMonitoria.controls['dsData'].setValue(beanMonitoria.moniDsData == null ? "" : beanMonitoria.moniDsData.replace(' ', 'T'));

    this.formularioMonitoria.controls['nrHora'].setValue(beanMonitoria.moniNrHora);


  }

  public listarPerfil() {

    this.profileService.listarProfiles().then((retorno: any) => {

      this.lstCmbPerfil = retorno;


    },
      errorResponse => { //CASO ERRO
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Perfis disponíveis', 'Lista Perfil');

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });
  }

  public listarStatusAtivo() {

    this.statusService.listarStatusAtivos().then((retorno: any) => {

      this.lstCmbStatus = retorno;


    },
      errorResponse => { //CASO ERRO
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Status disponíveis para a operação selecionada', 'Lista Formulários');

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });
  }

  public listarStatusMonitory(moniIdCdMonitoria: string) {

    this.statusMonitoryService.listarStatusMonitory(moniIdCdMonitoria)
      .toPromise()
      .then(lstBeanStatusMonitory => {

        lstBeanStatusMonitory.forEach(beanStatusMonitory => {

          beanStatusMonitory.stmoDhRegistro = this.datePipe.transform(new Date(beanStatusMonitory.stmoDhRegistro), 'dd/MM/yyyy HH:mm');


        });

        this.lstBeanStatusMonitory = lstBeanStatusMonitory;

      }, errorResponse => {

        this.setSessionExpired(errorResponse);

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });
  }

  //STATUS = AGUARDANDO FEEDBACK EM PROD é ID 9, em HOMOL ID 8.
  validaStatusAguardandoFeedback(): boolean {

    if (Number(this.lstBeanStatusMonitory[this.lstBeanStatusMonitory.length - 1].status.statIdCdStatus) != 9) {

      return false;
    }

    return true;
  }

  //STATUS = AGUARDANDO AVALIADOR REGULAR = ID 11
  validaStatusAvaliadorRegular(): boolean {

    if (Number(this.lstBeanStatusMonitory[this.lstBeanStatusMonitory.length - 1].status.statIdCdStatus) != 11) {

      return false;
    }

    return true;
  }

  public vincularStatusMonitory() {



    if (this.formularioMonitoria.controls.statIdCdStatus.value == "") {
      return;
    }

    //this.isSpinnerAddStatus = true;

    this.beanStatusMonitory.statIdCdStatus = this.formularioMonitoria.controls.statIdCdStatus.value;
    this.beanStatusMonitory.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria;
    this.beanStatusMonitory.usuaIdCdUsuario = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());

    //ROGÉRIO NUNES - adicionado para a verificação de envio de email
    this.beanStatusMonitory.operIdCdOperacao = this.beanMonitoria.operIdCdOperacao;

    this.statusMonitoryService.addStatusMonitory(this.beanStatusMonitory, this.qtdApontamentoGrave).then((retorno: any) => {

      this.idStatusMonitoriaAdicionado = retorno.stmoIdCdStatusMonitoria;

      this.listarStatusMonitory(this.beanMonitoria.moniIdCdMonitoria);

      this.necessarioStatus = false; // Deixar salvar após incluir o status
      this.toastr.success(' Vinculo efetuado!');

      this.salvarRegularAppraiser();
      //this.isSpinnerAddStatus = false;



    },
      errorResponse => {

        this.setSessionExpired(errorResponse);

      }).catch((retorno: any) => {

        //this.isSpinnerAddStatus = false;

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });



    this.formularioMonitoria.controls.statIdCdStatus.setValue("");

  }


  public add(): void {

  }



  // --- FORMA CABEÇALHO ---
  formFieldsCabecalho: BeanParameter[];
  formFieldsCabecalhoMotivo: BeanParametroXMotivo[];

  public formCabecalho = new FormGroup({});

  onChangeMontarFormulario() {


    // monta a ficha de monitoria [cabeçalho e perguntas]
    this.montarCamposDaFichaDinamicos();

    //popula a ficha de monitoria com os dados da tabela de monitoria
    this.preencheCamposDaTelaMonitoria(this.beanMonitoria);


  }







  /** METODO PARA ADICIONAR OS CAMPOS DINAMICOS DE CABEÇALHO E DE PERGUNTAS */
  public montarCamposDaFichaDinamicos() {



    let parameters;
    let parametersMotivo;

    //CARREGAR PARAMETROS ** CABEÇALHO
    this.cadastroFichaMonitoriaService.getParametersByIdForm(this.formularioMonitoria.value.idFormulario).subscribe(retorno => {
      parameters = retorno;
    },
      errorResponse => {
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Parametros ativos para este formulário', 'Lista Parametros');
      });


    //CARREGAR PARAMETROS COM MOTIVOS ** CABEÇALHO
    this.cadastroFichaMonitoriaService.listarParametroXMotivo(this.formularioMonitoria.value.idFormulario).subscribe(retorno => {
      parametersMotivo = retorno;

    
      this.cadastroFichaMonitoriaService.listarFormularioEspecifico(this.formularioMonitoria.value.idFormulario).subscribe(retorno => { 

        parameters = retorno.parameters;
        this.beanFormulario = retorno;


        //if(this.beanFormulario.formDsTipoPontuacao=='SOMA'){
        //adiciona pontuação na header do grupo categornia
        this.atualizarDetalhesAgrupadores(Number(this.beanMonitoria.moniIdCdMonitoria))
        //}



        //adiciona se existe comentario

        //adiciona se existe contestação

        //adiciona se tem NCG

        this.beanFormulario.parametersMotivos = parametersMotivo;



        //MONTAR PERGUNTAS MARCADAS COMO DEFAULT (MARCAR COM CHECK NA TELA)
        //Correção inserido o set formulario em atualizarMonitoriaEnviandoCampo() **resposta voltando o check errado de outras perguntas quando fecha a tela de comentario sem salvar
        if (this.beanMonitoria.formIdCdFormulario != null && this.beanMonitoria.formIdCdFormulario != "") {
          //this.validaPerguntasDefault();
          //this.validaPerguntaComentada();
        }

        //CRIAR FORM CABEÇALHO
        for (const formField of this.beanFormulario.parameters) {

          let isAddControl = false;

          for (var monitoryDataBase of this.beanMonitoria.monitoryParameter) {

            let controlNameidPamoIdPara = monitoryDataBase.pamoIdCdParametroFormulario + ":" + formField.paraIdCdParametro
            let idParametro = controlNameidPamoIdPara.substring(controlNameidPamoIdPara.indexOf(":") + 1, controlNameidPamoIdPara.length)
            //CASO EXISTA VALOR REGISTRADO NO BANCO TABELA PAMO MOSTRAR O VALOR
            if (Number(idParametro) == monitoryDataBase.paraIdCdParametro) {
              this.formCabecalho.addControl(controlNameidPamoIdPara, new FormControl('', this.getValidator(formField)));
              this.formCabecalho.controls[controlNameidPamoIdPara].setValue(monitoryDataBase.paraDsValue);
              isAddControl = true;
              formField.pamoIdCdParametroFormulario = monitoryDataBase.pamoIdCdParametroFormulario
              //CORREÇÃO DE DUPLICAÇÃO DO CABEÇALHO AO GRAVAR DUAS (OU MAIS) VEZES UM FORMULARIO NOVO
              this.formCabecalho.removeControl(formField.paraIdCdParametro);

              break

            } else {
              formField.pamoIdCdParametroFormulario = 0
            }

          }

          if (!isAddControl) {
            formField.pamoIdCdParametroFormulario = 0
            let controlNameIdPara = formField.paraIdCdParametro;

            //ADICIONA AO formCabecalho OS CAMPOS RETORNADOS DO CADASTRO (apenas se não foi criado com values da PAMO)
            if (formField.paraDhInativo == null) {
              this.formCabecalho.addControl(controlNameIdPara, new FormControl('', this.getValidator(formField)));
            } else {
              this.formCabecalho.addControl(controlNameIdPara, new FormControl(''));
            }

          }
        }




        for (let i = 0; i < this.beanFormulario.parameters.length; i++) {

          this.beanFormulario.parameters[i].beanParametroXMotivo = []

          if (this.beanFormulario.parametersMotivos != null && this.beanFormulario.parametersMotivos != undefined) {

            for (let j = 0; j < this.beanFormulario.parametersMotivos.length; j++) {

              if (this.beanFormulario.parameters[i].paraIdCdParametro == this.beanFormulario.parametersMotivos[j].paraIdCdParametro) {

                this.beanFormulario.parameters[i].beanParametroXMotivo.push(this.beanFormulario.parametersMotivos[j])
                this.marcadorCabecalhoMotivo = true
              }
            }
          }


        }

          this.formFieldsCabecalho = this.beanFormulario.parameters;


          //MONTAR LISTA DE STATUS
          this.listarStatusMonitory(this.beanMonitoria.moniIdCdMonitoria);

          this.isLiberarCriarFicha = true;

        },

        errorResponse => { //CASO ERRO
          this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Status disponíveis para a operação selecionada', 'Lista Formulários');
        });


    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }









  loadDialogParametroMotivos(beanParameter: BeanParameter) {

    if (!this.isFinalizado) {
      //this.isSpinnerUpdateMonitoria = true;
    }

    //preencher combo com motivos na tela
    let lstBeanMotivo: BeanMotivo[] = []
    for (let beanMotivo of this.beanFormulario.parametersMotivos) {
      if (beanMotivo.paraIdCdParametro == beanParameter.paraIdCdParametro) {
        lstBeanMotivo.push(beanMotivo.motive)
      }
    }



    if (beanParameter.pamoIdCdParametroFormulario == undefined || beanParameter.pamoIdCdParametroFormulario == 0) {

      this.salvarParametrosMonitoria(Number(beanParameter.paraIdCdParametro)).then((retorno: BeanMonitoryParameter[]) => {

        const dialogRef = this.dialog.open(ParametroMotivoDialogDialog, {
          width: '50%',
          height: '700px'

        });

        dialogRef.componentInstance.lstCmbBeanMotivo = lstBeanMotivo;
        dialogRef.componentInstance.beanParameter = beanParameter;
        dialogRef.componentInstance.moniIdCdMonitoria = Number(this.beanMonitoria.moniIdCdMonitoria);

        dialogRef.componentInstance.beanMonitoryParameter = retorno;

        let beanMonitoryParameter = retorno;

        dialogRef.afterClosed().subscribe(result => {
          //this.isSpinnerUpdateMonitoria = false;

          beanParameter.pamoIdCdParametroFormulario = result.idPamo


          if (result.returnBean != undefined && result.returnBean != null) {

            //**** SE SALVAR NA TELA DE VINCULOS UMA DESCRIÇÃO DO PARAMETERO

            let monitoryParameter: BeanMonitoryParameter = new BeanMonitoryParameter(result.idPamo,
              Number(this.beanMonitoria.moniIdCdMonitoria),
              Number(beanParameter.paraIdCdParametro),
              result.descricao,
              null, null, null)

            this.beanMonitoria.monitoryParameter.push(monitoryParameter)


          } else {

            //**** SE NÃO CLICAR NO BOTÃO SALVAR NA TELA DE VINCULOS
            //REPLACE SALVO NA TELA ANTERIOR
            this.beanMonitoria.monitoryParameter.push(beanMonitoryParameter[0])

          }

          this.montarCamposDaFichaDinamicos();

        });

      },
        errorResponse => { //CASO ERRO
          this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao gravar Parametro Monitoria', 'Parametro Monitoria');

        }).catch((retorno: any) => {

          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
        });



    } else {


      const dialogRef = this.dialog.open(ParametroMotivoDialogDialog, {
        width: '50%',
        height: '700px'

      });

      dialogRef.componentInstance.lstCmbBeanMotivo = lstBeanMotivo;
      dialogRef.componentInstance.beanParameter = beanParameter;
      dialogRef.componentInstance.moniIdCdMonitoria = Number(this.beanMonitoria.moniIdCdMonitoria);

      dialogRef.componentInstance.beanMonitoryParameter = this.beanMonitoria.monitoryParameter.filter(t => t.paraIdCdParametro === Number(beanParameter.paraIdCdParametro));


      dialogRef.afterClosed().subscribe(result => {
        //this.isSpinnerUpdateMonitoria = false;


        if (result.returnBean != undefined && result.returnBean != null) {

          //REPLACE SALVO NA TELA ANTERIOR
          this.beanMonitoria.monitoryParameter.forEach(beanPamo => {
            beanPamo.pamoIdCdParametroFormulario == result.returnBean.pamoIdCdParametroFormulario ? beanPamo.paraDsValue = result.returnBean.paraDsValue : beanPamo.paraDsValue = beanPamo.paraDsValue
          });


        }

        this.montarCamposDaFichaDinamicos();


      });





    }


  }









  //VALIDAR CAMPOS DINAMICOS
  private getValidator(formFieldCabecalho: BeanParameter): ValidatorFn {
    switch (formFieldCabecalho.paraInObrigatorio) {
      case "S":
        return Validators.required;
      default:
        return null;
    }
  }


  /** MARCAR AS PERGUNTAS QUE ESTÃO COMO DEFAULT NO BANCO AO ABRIR O ACCORDION COLAPSE */
  public validaPerguntasDefaultColapse(listGroupCategory: BeanCategoryGroup[], idCategoria: number) {

    let listCategorias = listGroupCategory[0].categories;
    let categoria = listCategorias.filter(z => z.cateIdCdCategoria == idCategoria);


    let idGrupoCategoriaFormulario = listGroupCategory[0].grcaIdCdGrupoCategoria;
    let idCategoriaFormulario = categoria[0].cateIdCdCategoria;

    // listar QUESTÕES (PERGUNTAS) para o GRUPO e CATEGORIA expandidos
    let listPerguntasFormulario = categoria[0].questions;

    for (let i = 0; i < listPerguntasFormulario.length; i++) {
      const questaoFormulario = listPerguntasFormulario[i];

      for (let i4 = 0; i4 < questaoFormulario.questionAnswers.length; i4++) {
        const questaoRespostaFormulario = questaoFormulario.questionAnswers[i4];

        //Se a monitoria ja estiver salva usar o bean monitoria
        if (this.beanMonitoria.monitoryQuestionAnswers.length > 0) {

          // MARCAR COMO N TODAS AS RESPOSTAS
          listPerguntasFormulario[i].questionAnswers[i4].pereInRespostaDefault = "N";

          for (let k = 0; k < this.beanMonitoria.monitoryQuestionAnswers.length; k++) {

            const questionAnswerMonitoria = this.beanMonitoria.monitoryQuestionAnswers[k];

            if (idGrupoCategoriaFormulario == questionAnswerMonitoria.grcaIdCdGrupoCategoria
              && idCategoriaFormulario == questionAnswerMonitoria.cateIdCdCategoria
              && questaoRespostaFormulario.pergIdCdPergunta == questionAnswerMonitoria.pergIdCdPergunta
              && questionAnswerMonitoria.respIdCdResposta != null
              && questionAnswerMonitoria.respIdCdResposta > 0) {

              if (questaoRespostaFormulario.answer.respIdCdResposta == questionAnswerMonitoria.respIdCdResposta) {

                // MARCAR COMO S APENAS OS CASOS QUE RETORNARAM DO BANCO COMO "FLAGADO"
                listPerguntasFormulario[i].questionAnswers[i4].pereInRespostaDefault = "S";

                if (listPerguntasFormulario[i].questionAnswers[i4].pereInZerar == 'S') {
                  //this.qtdApontamentoGrave++
                }

              }

            }
          }

        }

      }
    }

  }


  public validaPerguntasDefault() {

    let qtdPontuacaoNormal = 0;
    let qtdPontuacaoExtra = 0;

    for (let i1 = 0; i1 < this.beanFormulario.categoryGroups.length; i1++) {
      const formGrca = this.beanFormulario.categoryGroups[i1];

      for (let i2 = 0; i2 < formGrca.categories.length; i2++) {
        const formCate = formGrca.categories[i2];

        for (let i3 = 0; i3 < formCate.questions.length; i3++) {
          const formQues = formCate.questions[i3];

          for (let i4 = 0; i4 < formQues.questionAnswers.length; i4++) {
            const formQa = formQues.questionAnswers[i4];

            this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].questionAnswers[i4].pereInRespostaDefault = "N";

            for (let k = 0; k < this.beanMonitoria.monitoryQuestionAnswers.length; k++) {
              const moniQA = this.beanMonitoria.monitoryQuestionAnswers[k];

              if (formGrca.grcaIdCdGrupoCategoria == moniQA.grcaIdCdGrupoCategoria
                && formCate.cateIdCdCategoria == moniQA.cateIdCdCategoria
                && formQa.pergIdCdPergunta == moniQA.pergIdCdPergunta
                && moniQA.respIdCdResposta != null
                && moniQA.respIdCdResposta > 0) {

                if (formQa.answer.respIdCdResposta == moniQA.respIdCdResposta) {

                  //CHECA O CAMPO DEFAUT APENAS PARA O CHECK NAS RESPOSTAS QUE JA FORAM RESPONDIDAS ANTES
                  this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].questionAnswers[i4].pereInRespostaDefault = "S";

                  if (this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].questionAnswers[i4].pereInZerar == 'S') {
                    this.qtdApontamentoGrave++
                  }

                }

              }
            }
          }
        }
      }
    }

    //ATUALIZAR PONTOS AO CARREGAR A MONITORIA
    //this.getAtualizaNrPontosDaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria))

  }


  validaPerguntaComentadaColapse(listGroupCategory: BeanCategoryGroup[], idCategoria: number) {


    let listCategorias = listGroupCategory[0].categories;
    let categoria = listCategorias.filter(z => z.cateIdCdCategoria == idCategoria);


    let idGrupoCategoriaFormulario = listGroupCategory[0].grcaIdCdGrupoCategoria;
    let idCategoriaFormulario = categoria[0].cateIdCdCategoria;

    // listar QUESTÕES (PERGUNTAS) para o GRUPO e CATEGORIA expandidos
    let listPerguntasFormulario = categoria[0].questions;


    for (let i = 0; i < listPerguntasFormulario.length; i++) {
      const questaoFormulario = listPerguntasFormulario[i];

      for (let i4 = 0; i4 < questaoFormulario.questionAnswers.length; i4++) {
        const questaoRespostaFormulario = questaoFormulario.questionAnswers[i4];

        for (let k = 0; k < this.beanMonitoria.monitoryQuestionAnswers.length; k++) {
          const moniQA = this.beanMonitoria.monitoryQuestionAnswers[k];

          if (questaoFormulario.pergIdCdPergunta == moniQA.pergIdCdPergunta) {

            this.monitoriaService.getComentario(moniQA.moniIdCdMonitoria, moniQA.grcaIdCdGrupoCategoria, moniQA.cateIdCdCategoria, moniQA.pergIdCdPergunta).then((retorno) => {

              this.beanMonitoria.monitoryQuestionAnswers[k].comment = retorno;

              let formIndexGrca = this.beanFormulario.categoryGroups.findIndex(x => x.grcaIdCdGrupoCategoria === idGrupoCategoriaFormulario);
              let formIndexCate = this.beanFormulario.categoryGroups[formIndexGrca].categories.findIndex(x => x.cateIdCdCategoria === idCategoriaFormulario);
              let formIndexQues = this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].questions.findIndex(x => x.pergIdCdPergunta === questaoFormulario.pergIdCdPergunta);

              //VALIDA SE POSSUI COMENTARIO
              if (this.beanMonitoria.monitoryQuestionAnswers[k].comment.recmNrSequencia != null && this.beanMonitoria.monitoryQuestionAnswers[k].comment.recmNrSequencia > 0) {
                this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].questions[formIndexQues].isCommented = true;
                this.alertComentario = true;

              }


              try {

                if (moniQA.contestations.length != null && moniQA.contestations.length > 0) {

                  for (let i5 = 0; i5 < moniQA.contestations.length; i5++) {

                    this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].questions[formIndexQues].permNrSequencia = moniQA.contestations[i5].permNrSequencia // setar o id da linha de pergunta X resposta
                    this.beanFormulario.categoryGroups[formIndexGrca].categories[formIndexCate].questions[formIndexQues].isContested = true; //alertar na lista de perguntas
                    this.alertContestacao = true; //alertar parte superior da tela de monitoria

                  }

                }

              } catch {

              }


              //VALIDAR SE POSSUI CONTESTAÇÃO


            }, errorResponse => {

              this.setSessionExpired(errorResponse);


            }).catch((retorno: any) => {

              if (retorno.error.error_description.indexOf("Access token expired") > -1) {
                alert("Sessão Expirada");
                this.router.navigate(['']);
              }
            });
          }

          if (this.sessionExpired) {

            break;
          }
        }

        if (this.sessionExpired) {

          break;
        }
      }

      if (this.sessionExpired) {

        break;
      }
    }







  }

  //atualizar todas as respostas com seus comentarios e contestações
  validaPerguntaComentada() {

    for (let i1 = 0; i1 < this.beanFormulario.categoryGroups.length; i1++) {
      const formGrca = this.beanFormulario.categoryGroups[i1];

      for (let i2 = 0; i2 < formGrca.categories.length; i2++) {
        const formCate = formGrca.categories[i2];

        for (let i3 = 0; i3 < formCate.questions.length; i3++) {
          const formQues = formCate.questions[i3];

          for (let i4 = 0; i4 < formQues.questionAnswers.length; i4++) {
            const formQa = formQues.questionAnswers[i4];

            for (let k = 0; k < this.beanMonitoria.monitoryQuestionAnswers.length; k++) {
              const moniQA = this.beanMonitoria.monitoryQuestionAnswers[k];

              if (formGrca.grcaIdCdGrupoCategoria == moniQA.grcaIdCdGrupoCategoria && formCate.cateIdCdCategoria == moniQA.cateIdCdCategoria
                && formQues.pergIdCdPergunta == moniQA.pergIdCdPergunta) {

                this.monitoriaService.getComentario(moniQA.moniIdCdMonitoria, moniQA.grcaIdCdGrupoCategoria, moniQA.cateIdCdCategoria, moniQA.pergIdCdPergunta).then((retorno) => {

                  this.beanMonitoria.monitoryQuestionAnswers[k].comment = retorno;

                  if (this.beanMonitoria.monitoryQuestionAnswers[k].comment.recmNrSequencia != null && this.beanMonitoria.monitoryQuestionAnswers[k].comment.recmNrSequencia > 0) {

                    this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].isCommented = true;
                    this.alertComentario = true;

                  }

                  try {

                    //VALIDAR SE POSSUI CONTESTAÇÃO
                    if (moniQA.contestations.length != null && moniQA.contestations.length > 0) {

                      for (let i5 = 0; i5 < moniQA.contestations.length; i5++) {

                        this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].permNrSequencia = moniQA.contestations[i5].permNrSequencia // setar o id da linha de pergunta X resposta
                        this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].isContested = true; //alertar na lista de perguntas
                        this.alertContestacao = true; //alertar parte superior da tela de monitoria

                      }

                    }


                  } catch {

                  }


                }, errorResponse => {

                  this.setSessionExpired(errorResponse);


                }).catch((retorno: any) => {

                  if (retorno.error.error_description.indexOf("Access token expired") > -1) {
                    alert("Sessão Expirada");
                    this.router.navigate(['']);
                  }
                });
              }

              if (this.sessionExpired) {

                break;
              }
            }

            if (this.sessionExpired) {

              break;
            }
          }

          if (this.sessionExpired) {

            break;
          }
        }

        if (this.sessionExpired) {

          break;
        }
      }

      if (this.sessionExpired) {

        break;
      }
    }
  }

  async salvarFichaMonitoria() {

    this.btnSalvarFichaHidden = "none";

    this.getPergRespBeanForm().then((lstMonitoryQA: BeanMonitoryQuestionAnswer[]) => {

      this.monitoriaService.carregaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria), this.idUsuarioLogado, this.tipoUsuarioLogado) 
        .then((responseMonitoria: any) => {


          //incluir o id do formulario na monitoria
          this.atualizarMonitoriaEnviandoCampo('idFormulario');

          //bloquear o campo de formulario
          this.formIdFormularioDisabled = "none";



          if (lstMonitoryQA.length > 0) {



            this.monitoriaService.criaMonitoryQuestionAnswerByList(lstMonitoryQA, Number(this.beanMonitoria.moniIdCdMonitoria)).subscribe(response => {
              this.beanMonitoria.monitoryQuestionAnswers = response;

              //ATUALIZAR PONTOS AO CRIAR A MONITORIA
              this.getAtualizaNrPontosDaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria))
              //this.isSpinnerUpdateMonitoria = false;

            }, errorResponse => {

              this.setSessionExpired(errorResponse);
            });




            /* INSERIR PERGUTAS E RESPOSTAS UMA A UMA
            for (let index = 0; index < lstMonitoryQA.length; index++) {

              this.monitoriaService.criaMonitoryQuestionAnswer(lstMonitoryQA[index]).subscribe( response => {
                response.comment = new BeanMonitoryCommentReply();
                response.contestations = [];
                this.beanMonitoria.monitoryQuestionAnswers.push(response);
              }, errorResponse => {

                this.setSessionExpired(errorResponse);
              });

              if(this.sessionExpired){
                break;
              }
            }*/


          }

          //this.validaPerguntaComentada();

          this.toastr.success('Atualizada com sucesso', 'Lista Formulários');
          this.formStartDisabled = "none";
          this.formContentDisabled = "auto";
          //this.btnSalvarFichaHidden = "none";
          this.toastr.info('Ficha liberada para a edição', 'Lista Formulários');



        }, errorResponse => {

          this.btnSalvarFichaHidden = "auto";
          this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'CARREGAR MONITORIA');
          this.btnSalvarFichaHidden = "auto";

        }).catch((retorno: any) => {
          this.btnSalvarFichaHidden = "auto";
          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
        });


    },
      errorResponse => { //CASO ERRO

        this.btnSalvarFichaHidden = "auto";
        this.setSessionExpired(errorResponse) ? true : this.toastr.error(errorResponse.error.message, 'Construção das respostas');

      }).catch((retorno: any) => {
        this.btnSalvarFichaHidden = "auto";
        if (retorno.error.error_description.indexOf("Access token expired") > -1) {

          alert("Sessão Expirada");
          this.router.navigate(['']);
        }

      });



  }

  public getPergRespBeanForm(): Promise<BeanMonitoryQuestionAnswer[]> {

    var lstMonitoryQA: BeanMonitoryQuestionAnswer[] = [];

    for (let i1 = 0; i1 < this.beanFormulario.categoryGroups.length; i1++) {
      const lstCategory = this.beanFormulario.categoryGroups[i1].categories;

      for (let i2 = 0; i2 < lstCategory.length; i2++) {

        const lstQuestion = lstCategory[i2].questions;

        for (let i3 = 0; i3 < lstQuestion.length; i3++) {
          const lstQuestionAnswers = lstQuestion[i3].questionAnswers;
          const monitoryQA: BeanMonitoryQuestionAnswer = new BeanMonitoryQuestionAnswer(null, null, null, null, null, null, null, [], null, null, null, null, null, null, null, null);

          //  monitoryQA.question =
          monitoryQA.question = lstQuestion[i3];

          for (let i4 = 0; i4 < lstQuestionAnswers.length; i4++) {
            if (lstQuestionAnswers[i4].pereInRespostaDefault == 'S') {

              monitoryQA.respIdCdResposta = lstQuestionAnswers[i4].respIdCdResposta;

              monitoryQA.answer = lstQuestionAnswers[i4].answer;

            }
          }

          monitoryQA.moniIdCdMonitoria = Number(this.beanMonitoria.moniIdCdMonitoria);
          monitoryQA.usuaIdCdUsuario = Number(this.beanMonitoria.userOperador[0].usuaIdCdUsuario);
          monitoryQA.grcaIdCdGrupoCategoria = this.beanFormulario.categoryGroups[i1].grcaIdCdGrupoCategoria;
          monitoryQA.cateIdCdCategoria = lstCategory[i2].cateIdCdCategoria;
          monitoryQA.pergIdCdPergunta = lstQuestion[i3].pergIdCdPergunta;

          let questionAnswer = lstQuestion[i3].questionAnswers.filter(t => t.respIdCdResposta == monitoryQA.respIdCdResposta && //600
            t.pergIdCdPergunta == lstQuestion[i3].pergIdCdPergunta //4828
          )[0] //922
          if (questionAnswer != undefined) {
            monitoryQA.pereNrPonto = questionAnswer.pereNrPonto
            monitoryQA.pereNrPontoExtra = questionAnswer.pereNrPontoExtra
          }


          lstMonitoryQA.push(monitoryQA);
        }

      }
    }

    return Promise.resolve(lstMonitoryQA);
  }












  finalArray: any[] = [];

  public changeResp(event, data: BeanQuestion) {

    this.necessarioStatus = true; 
    let exigecomentario = false;

    let idResposta = event.value; // tipo check (radio button)
    //let idescrição = event.target.options[event.target.selectedIndex].text;
    if (idResposta == undefined) {
      idResposta = event.target.value //tipo select (select combo)
    }


    //this.isSpinnerUpdateMonitoria = true;
    const monitoryQA: BeanMonitoryQuestionAnswer = new BeanMonitoryQuestionAnswer(null, null, null, null, null, null, null, [], null, null, null, null, null, null, null, null);




    for (let index = 0; index < this.beanMonitoria.monitoryQuestionAnswers.length; index++) {
      const obj = this.beanMonitoria.monitoryQuestionAnswers[index];

      if (obj.cateIdCdCategoria == data.cateIdCdCategoria && obj.pergIdCdPergunta == data.pergIdCdPergunta) {

        const QA = data.questionAnswers.filter(t => t.respIdCdResposta === Number(idResposta))[0];



        try {
          obj.comment.recmNrSequencia
        } catch (e) {
          obj.comment = new BeanMonitoryCommentReply;
          obj.comment.recmNrSequencia = null
          this.validaPerguntaComentada()

        }



        try {
          obj.contestations
        } catch (e) {
          obj.contestations = [];
        }



        if (QA != undefined) {

          if (QA.pereInComentario != 'N' && (obj.comment.recmNrSequencia == undefined || obj.comment.recmNrSequencia == null)) {
            exigecomentario = true;
          }

        }



        // Ao respoder exige comenterio?
        if (exigecomentario) {

          const dialogRef = this.dialog.open(ComentarioMonitoriaDialog, {
            width: '50%',
            height: '80%',
            data: {
              mqa: obj,
              permParaComentar: this.permParaComentar,
              isCommented: false,
              idRespSelecionado: Number(idResposta)
            }
          });

          dialogRef.afterClosed().subscribe(result => {


            if (result != null && result != undefined) {

              if (result.recmTxComentario != undefined) {

                //this.isSpinnerUpdateMonitoria = false;
                this.toastr.warning('Essa PERGUNTA x RESPOSTA exige comentário!');
                this.montarCamposDaFichaDinamicos();
                return;

              }

              if (result.sessionExpired) {

                this.sessionExpired = result.sessionExpired;
                this.resetSessionExpired();

              } else {

                monitoryQA.moniIdCdMonitoria = Number(this.beanMonitoria.moniIdCdMonitoria);
                monitoryQA.usuaIdCdUsuario = Number(this.beanMonitoria.userOperador[0].usuaIdCdUsuario);
                monitoryQA.grcaIdCdGrupoCategoria = obj.grcaIdCdGrupoCategoria;
                monitoryQA.cateIdCdCategoria = data.cateIdCdCategoria;
                monitoryQA.pergIdCdPergunta = data.pergIdCdPergunta;
                monitoryQA.respIdCdResposta = Number(idResposta);
                monitoryQA.permNrSequencia = obj.permNrSequencia;



                let questionAnswer = data.questionAnswers.filter(t => t.respIdCdResposta == Number(idResposta) && //600
                  t.pergIdCdPergunta == data.pergIdCdPergunta //4828
                )[0] //922

                monitoryQA.pereNrPonto = questionAnswer.pereNrPonto
                monitoryQA.pereNrPontoExtra = questionAnswer.pereNrPontoExtra
                monitoryQA.answer = questionAnswer.answer;

                this.monitoriaService.atualizaMonitoryQuestionAnswer(monitoryQA).subscribe(response => {

                  this.necessarioStatus = true;

                  this.getAtualizaNrPontosDaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria))

                  this.monitoriaService.carregaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria), this.idUsuarioLogado, this.tipoUsuarioLogado)
                    .then((responseMonitoria: any) => {

                      this.beanMonitoria.monitoryQuestionAnswers = [];
                      this.beanMonitoria.monitoryQuestionAnswers = responseMonitoria.monitoryQuestionAnswers;
                      this.validaPerguntaComentada();
                      //this.isSpinnerUpdateMonitoria = false;

                    }, errorResponse => {

                      //this.isSpinnerUpdateMonitoria = false;
                      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'CARREGAR MONITORIA');

                    }).catch((retorno: any) => {
                      //this.isSpinnerUpdateMonitoria = false;
                      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
                        alert("Sessão Expirada");
                        this.router.navigate(['']);
                      }
                    });

                  this.toastr.success('Resposta atualizada', 'Lista Formulários');

                }, errorResponse => {

                  this.setSessionExpired(errorResponse);
                });
              }

            } else {
              //this.isSpinnerUpdateMonitoria = false;
              this.toastr.warning('Essa PERGUNTA x RESPOSTA exige comentário!');
              this.montarCamposDaFichaDinamicos();

            }
          });

          break;

        } else {

          monitoryQA.moniIdCdMonitoria = Number(this.beanMonitoria.moniIdCdMonitoria);
          monitoryQA.usuaIdCdUsuario = Number(this.beanMonitoria.userOperador[0].usuaIdCdUsuario);
          monitoryQA.grcaIdCdGrupoCategoria = obj.grcaIdCdGrupoCategoria;
          monitoryQA.cateIdCdCategoria = data.cateIdCdCategoria;
          monitoryQA.pergIdCdPergunta = data.pergIdCdPergunta;
          monitoryQA.permNrSequencia = obj.permNrSequencia;







          // CORREÇÃO ATUALIZAR COMENTARIO NA TABELA RECM : update id resposta do comentario
          if (obj.comment.recmNrSequencia != null) {

            this.beanMonitoryCommentReply.respIdCdResposta = idResposta; //resposta selecionada

            this.beanMonitoryCommentReply.usuaIdCdUsuario = obj.comment.usuaIdCdUsuario;
            this.beanMonitoryCommentReply.recmTxComentario = obj.comment.recmTxComentario;
            this.beanMonitoryCommentReply.recmNrSequencia = obj.comment.recmNrSequencia;
            this.beanMonitoryCommentReply.moniIdCdMonitoria = obj.comment.moniIdCdMonitoria;
            this.beanMonitoryCommentReply.grcaIdCdGrupoCategoria = obj.comment.grcaIdCdGrupoCategoria;
            this.beanMonitoryCommentReply.cateIdCdCategoria = obj.comment.cateIdCdCategoria;
            this.beanMonitoryCommentReply.pergIdCdPergunta = obj.comment.pergIdCdPergunta;

            this.monitoriaService.updateComentario(this.beanMonitoryCommentReply).then(() => {
              this.necessarioStatus = true;
            }, errorResponse => {

              this.setSessionExpired(errorResponse);
            })

          }




          //SE RETTIRAR RESPOSTA E DEIXAR VAZIO (NÃO EXISTIR DEFAULT) select option vazio
          if (idResposta != undefined && idResposta != 'undefined' && idResposta != null) {

            let questionAnswer = data.questionAnswers.filter(t => t.respIdCdResposta == Number(idResposta) && //600
              t.pergIdCdPergunta == data.pergIdCdPergunta //4828
            )[0] //922

            monitoryQA.respIdCdResposta = Number(idResposta);
            monitoryQA.pereNrPonto = questionAnswer.pereNrPonto
            monitoryQA.pereNrPontoExtra = questionAnswer.pereNrPontoExtra
            monitoryQA.answer = questionAnswer.answer;


          } else {

            monitoryQA.respIdCdResposta = null;
            monitoryQA.pereNrPonto = null;
            monitoryQA.pereNrPontoExtra = null;
            monitoryQA.answer = null

          }





          this.monitoriaService.atualizaMonitoryQuestionAnswer(monitoryQA).subscribe(response => {
            this.getAtualizaNrPontosDaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria))
            this.necessarioStatus = true;
          }, errorResponse => {

            this.setSessionExpired(errorResponse);
          });



          ///ADD O DEFAULT NOVO

          ///RETIRAR O DEFAULT ANTIGO ( caso seja umamonitoria nova pode não ter uma pesgunta default)
          try {
            data.questionAnswers.filter(x => x.pereInRespostaDefault == 'S')[0].pereInRespostaDefault = 'N';
            let newQuestion: BeanQuestion = new BeanQuestion(null, null, null, null, null, null, null, null, null, null, null, null, null);
            newQuestion = data;
            newQuestion.questionAnswers.filter(x => x.answer.respIdCdResposta == idResposta)[0].pereInRespostaDefault = 'S';

          } catch {

          }






          //comentario acima para que não traga tudo denovo da monitoria
          //mas que atualize apenas o indice com a informação selecionada
          this.beanMonitoria.monitoryQuestionAnswers[index] = new BeanMonitoryQuestionAnswer(monitoryQA.permNrSequencia, monitoryQA.moniIdCdMonitoria, monitoryQA.grcaIdCdGrupoCategoria, monitoryQA.cateIdCdCategoria, monitoryQA.pergIdCdPergunta,
            monitoryQA.respIdCdResposta, monitoryQA.usuaIdCdUsuario, monitoryQA.contestations, monitoryQA.comment, monitoryQA.categoryGroup, monitoryQA.category,
            data, monitoryQA.answer, monitoryQA.user, monitoryQA.pereNrPonto, monitoryQA.pereNrPontoExtra);



          this.validaPerguntaComentada();


          this.toastr.success('Resposta atualizada', 'Lista Formulários');
          break;
        }
      }
    }
  }

  public getAtualizaNrPontosDaMonitoria(idMonitoria: number) {
    //this.isSpinnerUpdateMonitoria = true;


    //SOMAR QUANTIDADE DE PONTOS CADASTRADAS NO BANCO
    this.monitoriaService.getNrPointsOfMonitory(idMonitoria, this.beanFormulario.formDsTipoPontuacao)
      .then((totalDePontosNormal: any) => {


        if (this.beanFormulario.formDsTipoPontuacao == "MEDIA") {

          this.monitoriaService.getNrExtraPointsOfMonitory(idMonitoria, this.beanFormulario.formDsTipoPontuacao)
            .then((totalDePontosExtras: any) => {


              setTimeout(() => {



                //VALOR DA MÉDIA NORMAL
                this.formularioMonitoria.controls['nrPontuacaoNormal'].setValue(
                  totalDePontosNormal.toFixed(2).indexOf(".00") > -1 ?
                    totalDePontosNormal.toFixed(2).substring(0, totalDePontosNormal.toFixed(2).indexOf(".00")) :
                    (totalDePontosNormal + "").indexOf(".") > -1 ? totalDePontosNormal.toFixed(2) : totalDePontosNormal

                );



                if (totalDePontosExtras != null && totalDePontosExtras != '') {
                  //VALOR DA MÉDIA EXTRA
                  this.formularioMonitoria.controls['nrPontuacaoExtra'].setValue(
                    totalDePontosExtras.toFixed(2).indexOf(".00") > -1 ?
                      totalDePontosExtras.toFixed(2).substring(0, totalDePontosExtras.toFixed(2).indexOf(".00")) :
                      (totalDePontosExtras + "").indexOf(".") > -1 ? totalDePontosExtras.toFixed(2) : totalDePontosExtras


                  );
                }

                let totalDePontos = 0;

                if (totalDePontosNormal != null && totalDePontosNormal > 0) {
                  totalDePontos = totalDePontosNormal + totalDePontosExtras;
                }
                //VALOR TOTAL (NORMAL + EXTRA)
                this.formularioMonitoria.controls['nrPontuacao'].setValue(
                  totalDePontos.toFixed(2).indexOf(".00") > -1 ?
                    totalDePontos.toFixed(2).substring(0, totalDePontos.toFixed(2).indexOf(".00")) :
                    (totalDePontos + "").indexOf(".") > -1 ? totalDePontos.toFixed(2) : totalDePontos

                );


                this.atualizarMonitoriaEnviandoCampo('nrPontuacao');

                //CAUCULA QTD DE ITENS ZERADOS
                this.getQtdApontamentosZeradosGrave(idMonitoria);
                this.getQtdApontamentosZeradosNaoGrave(idMonitoria);

              }, 200);

            }, errorResponse => {

              this.setSessionExpired(errorResponse);

            }).catch((retorno: any) => {

              //this.isSpinnerUpdateMonitoria = false;
              if (retorno.error.error_description.indexOf("Access token expired") > -1) {
                alert("Sessão Expirada");
                this.router.navigate(['']);
              }
            });

        } else {


          this.formularioMonitoria.controls['nrPontuacao'].setValue(
            totalDePontosNormal
          );

          this.atualizarMonitoriaEnviandoCampo('nrPontuacao');

          //CAUCULA QTD DE ITENS ZERADOS
          this.getQtdApontamentosZeradosGrave(idMonitoria);
          this.getQtdApontamentosZeradosNaoGrave(idMonitoria);
        }




        //this.isSpinnerUpdateMonitoria = false;

      }, errorResponse => {

        this.setSessionExpired(errorResponse);

      }).catch((retorno: any) => {

        //this.isSpinnerUpdateMonitoria = false;
        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });

    this.beanMonitoria.moniNrTotalPontos = this.formularioMonitoria.value.nrPontuacao;

  }


  public getQtdApontamentosZeradosGrave(idMonitoria: number) {

    //SOMAR QUANTIDADE DE PERGUNTAS ZERADAS CADASTRADAS NO BANCO
    this.monitoriaService.getNrRespostasZeradasGraveMonitory(idMonitoria).then((totalDeRespostasZeradasMonitoria: any) => {

      this.qtdApontamentoGrave = totalDeRespostasZeradasMonitoria;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'COMBO GESTOR');

    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });

  }

  public getQtdApontamentosZeradosNaoGrave(idMonitoria: number) {

    //SOMAR QUANTIDADE DE PERGUNTAS ZERADAS CADASTRADAS NO BANCO
    this.monitoriaService.getNrRespostasZeradasNaoGraveMonitory(idMonitoria).then((totalDeRespostasZeradasMonitoria: any) => {

      this.qtdApontamentoNaoGrave = totalDeRespostasZeradasMonitoria;

    }, errorResponse => {
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.', 'APONTAMENTOS ZERADOS');

    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });

  }

  public listarJustificativasAtivas() {

    this.justificationService.listarJustificativasAtivas().then((retorno: any) => {

      this.lstJustificativa = retorno;

    },
      errorResponse => { //CASO ERRO
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Justificativa disponíveis', 'Lista Formulários');

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });
  }

  loadDialogContestacao(listMonitoryQuestionAnswer: BeanMonitoryQuestionAnswer[], pergIdCdPergunta: string) {

    if (!this.isFinalizado) {
      //this.isSpinnerUpdateMonitoria = true;
    }

    let beanPerguntaXResposta = listMonitoryQuestionAnswer.filter(t => t.pergIdCdPergunta === Number(pergIdCdPergunta))[0]


    //CORREÇÃO PARA SÓ GRAVAR COMENTÁRIOS ONDE TEMOS UMA RESPOSTA SELECIONADA ANTES
    if (beanPerguntaXResposta.respIdCdResposta == null) {
      this.toastr.warning("Favor selecionar uma resposta antes de contestar", "VALIDAÇÃO")
      return
    }


    const dialogRef = this.dialog.open(ContestacaoMonitoriaDialog, {
      width: '55%',
      height: '90%',
      data: {
        mqa: beanPerguntaXResposta,
        isContested: false,
      }

    });

    dialogRef.componentInstance.moniDhFeedbackAvaliado = this.beanMonitoria.moniDhFeedbackAvaliado;

    dialogRef.afterClosed().subscribe(result => {

      //this.isSpinnerUpdateMonitoria = false;

      if (result != null && result != undefined) {

        if (result.sessionExpired) {

          this.sessionExpired = result.sessionExpired;
          this.resetSessionExpired();

        } else {


          /*Não permitir que a resposta seja a mesma que estava antes da contestação quando a contestação for procedente*/
          if(result.contestations[0].contestationAnswers[0].recoInProcedente=='S'){
          
            this.isValidarRespostaContestada = true;

            this.idPerguntaContestacao = result.pergIdCdPergunta // pergunta selecionada
            this.idRespostaContestacao = result.answer.respIdCdResposta // resposta selecionada *** precisa ser outra na hora de salvar 

            this.toastr.warning("Lembre: Sempre que alterar a contestação como Procedente reveja a resposta para essa pergunta.", 'VALIDAR CONTESTAÇÃO', {timeOut: 8000})
          }

            
          this.validaPerguntaComentada();

          //APÓS ADICIONAR O STATUS VIA BACKEND ATUALIZAR A LISTA DE STATUS NA TELA
          this.listarStatusMonitory(this.beanMonitoria.moniIdCdMonitoria);
        }

      }
    });

  }

  loadComment(pergIdCdPergunta: string): string {
    let beanPerguntaXResposta = this.beanMonitoria.monitoryQuestionAnswers.filter(t => t.pergIdCdPergunta === Number(pergIdCdPergunta))[0];

    return beanPerguntaXResposta.comment == null ? "" : beanPerguntaXResposta.comment.recmTxComentario;
  }

  loadDialogComentario(pergIdCdPergunta: string) {

    if (!this.isFinalizado) {
      //this.isSpinnerUpdateMonitoria = true;
    }

    let beanPerguntaXResposta = this.beanMonitoria.monitoryQuestionAnswers.filter(t => t.pergIdCdPergunta === Number(pergIdCdPergunta))[0]

    //CORREÇÃO PARA SÓ GRAVAR COMENTÁRIOS ONDE TEMOS UMA RESPOSTA SELECIONADA ANTES
    if (beanPerguntaXResposta.respIdCdResposta == null || beanPerguntaXResposta.respIdCdResposta == undefined) {
      this.toastr.warning("Favor selecionar uma resposta antes de comentar", "VALIDAÇÃO")
      return
    }

    try {
      beanPerguntaXResposta.comment.recmNrSequencia
    } catch (e) {
      beanPerguntaXResposta.comment = new BeanMonitoryCommentReply;
      beanPerguntaXResposta.comment.recmNrSequencia = null
      this.validaPerguntaComentada()
    }


    const dialogRef = this.dialog.open(ComentarioMonitoriaDialog, {
      width: '50%',
      height: '80%',
      data: {
        mqa: beanPerguntaXResposta,
        permParaComentar: this.permParaComentar,
        isCommented: false
      }
    });

    dialogRef.componentInstance.moniDhFeedbackAvaliado = this.beanMonitoria.moniDhFeedbackAvaliado;

    dialogRef.afterClosed().subscribe(result => {

      //this.isSpinnerUpdateMonitoria = false;
      //console.log(result)
      //console.log(beanPerguntaXResposta.comment.recmTxComentario)

      if (result != null && result != undefined) {

        if (result.sessionExpired) {

          this.sessionExpired = result.sessionExpired;
          this.resetSessionExpired();

        } else {

        
          this.validaPerguntaComentada();
          this.listarStatusMonitory(this.beanMonitoria.moniIdCdMonitoria);
          
          if(result.adicionouComentario == true ){
            this.necessarioStatus = true;
          }

        }
      }
    });
  }

  loadDialogObservacao(pergDsObservacao: string) {

    const dialogRef = this.dialog.open(ObservacaoMonitoriaDialog, {
      width: '50%',
      height: '50%',
      data: {
        pergDsObservacao: pergDsObservacao
      }
    });
  }

  public permissaoParaComentar(): boolean {

    if (this.beanMonitoria.userMonitor[0].usuaIdCdUsuario == this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim()) {

      this.permParaComentar = true;
    }

    return this.permParaComentar;
  }

  public atualizarMonitoriaEnviandoCampo(campo: string) {

    //this.isSpinnerUpdateMonitoria = true;

    // ADICIONADO AO BEAN DE MONITORIA O ID DO FORMULARIO - ISTO CORRIGE :
    // AO *CLICAR NA RESPOSTA QUE EXIGE COMENTARIO E PREENCHE NO SEGUNDO ITEM QUE EXIGE COMENTARIO AO FECHAR SEM COLOCAR O COMENTARIO A PRIMEIRA OPÇÃO ESTAVA VOLTANDO PARA A RESPOSTA ANTERIOR
    this.beanMonitoria.formIdCdFormulario = this.formularioMonitoria.value.idFormulario;


    let beanUpdateMonitoria: BeanMonitoria = new BeanMonitoria(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, [], [], null, [], [], null, null);


    //beanUpdateMonitoria.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria;

    switch (campo) {



      case 'tempoOperacional':
        beanUpdateMonitoria.moniDsTempooperacional = this.perfilDeTempoDeOperacao
        break;

      case 'nrPontuacao':
        beanUpdateMonitoria.moniNrTotalPontos = this.formularioMonitoria.value.nrPontuacao
        break;

      case 'idFormulario':

        //this.beanMonitoria.forms[0].push(as)
        beanUpdateMonitoria.formIdCdFormulario = this.formularioMonitoria.value.idFormulario
        break;

      case 'idPerfil':
        beanUpdateMonitoria.moniTxAvaliador = this.formularioMonitoria.value.idPerfil
        break;

      case 'txAvaliador':
        beanUpdateMonitoria.moniTxAvaliador = this.formularioMonitoria.value.txAvaliador
        break;

      case 'txFeedback':
        beanUpdateMonitoria.moniTxFeedback = this.formularioMonitoria.value.txFeedback
        break;

      case 'txAvaliado':
        beanUpdateMonitoria.moniTxAvaliado = this.formularioMonitoria.value.txAvaliado
        break;

      case 'txAlteracao':
        beanUpdateMonitoria.moniTxAlteracao = this.formularioMonitoria.value.txAlteracao
        break;

      case 'txJustificativa':
        beanUpdateMonitoria.moniTxJustificativa = this.formularioMonitoria.value.txJustificativa
        beanUpdateMonitoria.justIdCdJustificativa = this.formularioMonitoria.value.idJustificativa
        break;

      case 'txObservacao':
        beanUpdateMonitoria.moniTxObservacao = this.formularioMonitoria.value.txObservacao
        break;

      case 'dsData':
        beanUpdateMonitoria.moniDsData = this.formularioMonitoria.value.dsData
        break;

      case 'nrHora':
        beanUpdateMonitoria.moniNrHora = this.formularioMonitoria.value.nrHora
        break;

      //case 'idJustificativa' :
      //beanUpdateMonitoria.justIdCdJustificativa = this.formularioMonitoria.value.idJustificativa
      //break;
    }

    this.cadastroFichaMonitoriaService.updateMonitoria(beanUpdateMonitoria, this.beanMonitoria.moniIdCdMonitoria).subscribe(retorno => {
      //this.isSpinnerUpdateMonitoria = false;

      this.necessarioStatus = true;

      if (campo == "nrPontuacao") {

        if (this.beanFormulario.formDsTipoPontuacao == 'SOMA') {
          //adiciona pontuação na header do grupo categornia
          this.atualizarDetalhesAgrupadores(Number(this.beanMonitoria.moniIdCdMonitoria))
        }
      }

    },
      errorResponse => { //CASO ERRO
        //this.isSpinnerUpdateMonitoria = true;
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Erro ao salvar campo de monitoria', 'UPDATE MONITORIA');

      }

    );

  }

  checkPontuacao() {
    this.beanFormulario.formDsTipoPontuacao = this.beanFormulario.formDsTipoPontuacao.indexOf('.00') > -1 ? this.beanFormulario.formDsTipoPontuacao.substring(0, this.beanFormulario.formDsTipoPontuacao.indexOf('.00')) : this.beanFormulario.formDsTipoPontuacao;

    alert(this.beanFormulario.formDsTipoPontuacao);

  }

  validaJustificativa() {

    this.beanStatusMonitory.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria;
    this.beanStatusMonitory.usuaIdCdUsuario = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());

    if (this.formularioMonitoria.value.idJustificativa == 1) {

      //DESLIGADO - TRAVAR A MONITORIA E SETAR STATUS MONITORIA FINALIZADA
      this.desabilitarTudo();
      this.beanStatusMonitory.statIdCdStatus = "2";

    } else {

      //OUTRO - SETAR STATUS MONITORIA JUSTIFICADA
      this.beanStatusMonitory.statIdCdStatus = "10";
    }

    this.statusMonitoryService.addStatusMonitory(this.beanStatusMonitory, this.qtdApontamentoGrave).then((retorno: any) => {

      this.idStatusMonitoriaAdicionado = retorno.stmoIdCdStatusMonitoria;

      this.toastr.success('Monitoria justificada');

      //this.isSpinnerAddStatus = false;

    },
      errorResponse => {

        this.setSessionExpired(errorResponse);

      }).catch((retorno: any) => {

        //this.isSpinnerAddStatus = false;

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });

    this.formularioMonitoria.controls.statIdCdStatus.setValue("");

    //this.ngOnInit();
    this.listarStatusMonitory(this.beanMonitoria.moniIdCdMonitoria);
    //this.dialogRef.close(true);
  }



  
  validarAlteracaoDeCampos(){

    if(this.bkpIdFormulario != this.formularioMonitoria.value.idFormulario){return true}
    if(this.bkpNrPontuacao != this.formularioMonitoria.value.nrPontuacao){return true} 
    if(this.bkpNrPontuacaoNormal != this.formularioMonitoria.value.nrPontuacaoNormal){return true}
    if(this.bkpNrPontuacaoExtra != this.formularioMonitoria.value.nrPontuacaoExtra){return true}
    if(this.bkpStatIdCdStatus != this.formularioMonitoria.value.statIdCdStatus){return true} 
    if(this.bkpIdPerfil != this.formularioMonitoria.value.idPerfil){return true}
    if(this.bkpTxAvaliador != this.formularioMonitoria.value.txAvaliador){return true}
    if(this.bkpTxFeedback != this.formularioMonitoria.value.txFeedback){return true}
    if(this.bkpTxAvaliado != this.formularioMonitoria.value.txAvaliado){return true} 
    if(this.bkpTxAlteracao != this.formularioMonitoria.value.txAlteracao){return true} 
    if(this.bkpIdJustificativa != this.formularioMonitoria.value.idJustificativa){return true} 
    if(this.bkpTxJustificativa != this.formularioMonitoria.value.txJustificativa){return true} 
    if(this.bkpTxObservacao != this.formularioMonitoria.value.txObservacao){return true} 
    if(this.bkpDsData != this.formularioMonitoria.value.dsData){return true} 
    if(this.bkpNrHora != this.formularioMonitoria.value.nrHora){return true} 
 
    
  }

  atualizarMonitoriaEnviandoBeanCompleto(tpEntrada: string) {

    //se houve alteração de formulário
    //if(this.necessarioStatus == true || this.validarAlteracaoDeCampos()){
    if(this.necessarioStatus == true){

      this.toastr.error("Após ALTERAÇÃO NA FICHA é necessário adicionar um status.", 'VALIDAR MONITORIA', {timeOut: 5000});
      //this.idTabelaAdicionarStatus.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });  //FOCUS NO STATUS DA TELA
      return;

    }

    /*VALIDAR SE A RESPOSTA DA CONTESTAÇÃO FOI ALTERADA QUANDO A CONTESTAÇÃO FOR PROCEDENTE*/
    if(this.isValidarRespostaContestada){
      
      this.idPerguntaContestacao;  // pergunta selecionada
      this.idRespostaContestacao; // resposta selecionada *** precisa ser outra na hora de salvar 

      let beanPergunaXResposta = this.beanMonitoria.monitoryQuestionAnswers.filter(t => t.pergIdCdPergunta === this.idPerguntaContestacao)[0];

      if(beanPergunaXResposta.answer.respIdCdResposta == this.idRespostaContestacao){
        this.toastr.error("Precisa alterar a resposta da contestação procedente", 'VALIDAR CONTESTAÇÃO', {timeOut: 5000})
        return;
      }

    }

    let idUsuarioLogado = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());

    let isValidado = true;
    let idLogMonitoria = 0;


    let json = JSON.stringify(this.beanMonitoria);
    let beanLogs: BeanLogs = new BeanLogs(null, this.beanMonitoria.moniIdCdMonitoria, "Salvar Monitoria", idUsuarioLogado, null, json, null);



    let msgPreenchimentoObrigatório = "";
    let count = 0;


    if (this.tipoUsuarioLogado == 4 && this.idUsuario != Number(this.beanMonitoria.usuaIdCdUsuarioMonitor)
      && tpEntrada == 'btnSalvar') {

      /*
      if (this.formularioMonitoria.value.idJustificativa == '' || this.formularioMonitoria.value.idJustificativa == null) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher o campo justificativa <br />`;
        isValidado = false;
      }

      if (this.formularioMonitoria.value.txJustificativa == '' || this.formularioMonitoria.value.txJustificativa == null) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher o campo Descrição da justificativa <br />`;
        isValidado = false;
      }
        */
      if (this.formularioMonitoria.value.txObservacao == '' || this.formularioMonitoria.value.txObservacao == null) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher o campo Observação <br />`;
        isValidado = false;
      }

      if (this.formularioMonitoria.value.dsData == '' || this.formularioMonitoria.value.dsData == null) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher o campo Data <br />`;
        isValidado = false;
      }

      if (this.formularioMonitoria.value.nrHora == '' || this.formularioMonitoria.value.nrHora == null) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher o campo Hora <br />`;
        isValidado = false;
      }

      if (!isValidado) {
        this.toastr.warning(`Para salvar a ficha será obrigatório:<br /> ${msgPreenchimentoObrigatório}`, 'UPDATE MONITORIA', { timeOut: 5000, enableHtml: true })
        //this.isSpinnerUpdateMonitoria = false;
        return isValidado
      }


    } else if (this.tipoUsuarioLogado == 4 && this.idUsuario != Number(this.beanMonitoria.usuaIdCdUsuarioMonitor)) {
      //return isValidado

    } else {

      if (this.formularioMonitoria.value.idPerfil == '' || this.formularioMonitoria.value.idPerfil == null) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher Perfil <br />`;
        isValidado = false;
      }
      if (this.tipoUsuarioLogado == 4 &&
        (this.formularioMonitoria.value.txAvaliador == '' || this.formularioMonitoria.value.txAvaliador == null)) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher Avaliador <br />`;
        isValidado = false
      }

      if (this.idStatusMonitoriaAdicionado == 0) {

        if (this.tipoUsuarioLogado == 3 && this.formularioMonitoria.value.txFeedback == null) {
          count++;
          msgPreenchimentoObrigatório += `${count}) Preencher o campo Feedback para assinar e encerrar a monitoria<br />`;
          isValidado = false;

        } /*else if (this.tipoUsuarioLogado != 3) {
          count++;
          msgPreenchimentoObrigatório += `${count}) Adicionar um Status <br />`;
          isValidado = false;
        }*/

      }

      if (this.formCabecalho.invalid) {
        count++;
        msgPreenchimentoObrigatório += `${count}) Preencher os cabeçalhos obrigatórios `;
        isValidado = false;
      }

      if (!isValidado) {
        this.toastr.warning(`Para salvar a ficha será obrigatório:<br /> ${msgPreenchimentoObrigatório}`, 'UPDATE MONITORIA', { timeOut: 5000, enableHtml: true })
        //this.isSpinnerUpdateMonitoria = false;
        return isValidado
      }

    }


    //GERAR controle de logs ao salvar
    this.logsService.addLogs(beanLogs).then((retorno: BeanLogs) => {

      idLogMonitoria = retorno.logsIdCdLogs;



      //UPDATE MONITORIA_MONI
      let beanUpdateMonitoria: BeanMonitoria = new BeanMonitoria(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, [], [], null, [], [], null, null);


      beanUpdateMonitoria.formIdCdFormulario = this.formularioMonitoria.value.idFormulario
      beanUpdateMonitoria.perfIdCdPerfil = this.formularioMonitoria.value.idPerfil
      beanUpdateMonitoria.moniTxAvaliador = this.formularioMonitoria.value.txAvaliador
      beanUpdateMonitoria.moniNrTotalPontos = this.formularioMonitoria.value.nrPontuacao
      beanUpdateMonitoria.moniTxFeedback = this.formularioMonitoria.value.txFeedback
      beanUpdateMonitoria.moniTxAvaliado = this.formularioMonitoria.value.txAvaliado
      beanUpdateMonitoria.moniTxAlteracao = this.formularioMonitoria.value.txAlteracao
      //beanUpdateMonitoria.moniTxJustificativa = this.formularioMonitoria.value.txJustificativa
      //beanUpdateMonitoria.justIdCdJustificativa = this.formularioMonitoria.value.idJustificativa
      beanUpdateMonitoria.usuaIdUsuarioOperador = Number(this.beanMonitoria.userOperador.usuaIdCdUsuario)
      beanUpdateMonitoria.moniDsTempooperacional = this.perfilDeTempoDeOperacao
      beanUpdateMonitoria.moniTxObservacao = this.formularioMonitoria.value.txObservacao
      beanUpdateMonitoria.moniDsData = this.formularioMonitoria.value.dsData
      beanUpdateMonitoria.moniNrHora = this.formularioMonitoria.value.nrHora

      //SE FOR O OPERADOR ASSINANDO O FEEDBACK
      if (this.tipoUsuarioLogado == 3 && this.formularioMonitoria.value.txFeedback != '') {
        beanUpdateMonitoria.moniDhFeedbackAvaliado = '1900-01-01T00:00:00';
        beanUpdateMonitoria.usuaIdCdUsuarioFeedback = this.getLastRegularAppraiser().user.usuaIdCdUsuario;
      }


      this.cadastroFichaMonitoriaService.updateMonitoria(beanUpdateMonitoria, this.beanMonitoria.moniIdCdMonitoria).subscribe(retorno => {

        //**** SALVAR CABEÇALHO DA MONITORIA "SALVAR GRANDÃO"
        this.salvarParametrosMonitoria(0);
        this.toastr.success('Monitoria salva com sucesso!', 'UPDATE MONITORIA')
        //this.dialogRef.close(true);

        if (this.tipoUsuarioLogado != 3) {

          this.salvarRegularAppraiser();
        }


        //ADICIONAR STATUS QUANDO HOUVER PREENCHIMENTO DO FEEDBACK
        if (beanUpdateMonitoria.moniTxFeedback != '' && beanUpdateMonitoria.moniTxFeedback != null) {

          this.dialogRef.close(true);

          //ALTERADO PARA ADICIONAR STATUS DE ENCERRAMENTO DA MONITORIA VIA BACKEND  updateMonitoria
          /*
          this.configuracaoService.getConfiguracaoByChave("grupoconfig.status.assinarfeedback").then((retorno:BeanConfiguracao)=>{

                let beanStatusMonitoryInicial : BeanStatusMonitory = new BeanStatusMonitory();

                  beanStatusMonitoryInicial.statIdCdStatus = retorno.confDsValString
                  beanStatusMonitoryInicial.moniIdCdMonitoria = this.beanMonitoria.moniIdCdMonitoria;
                  beanStatusMonitoryInicial.usuaIdCdUsuario = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());

                  //GERAR O STATUS
                  this.statusMonitoryService.addStatusMonitory(beanStatusMonitoryInicial, this.qtdApontamentoGrave).then((retorno:BeanStatusMonitory)=>{
                      this.idStatusMonitoriaAdicionado = Number(beanStatusMonitoryInicial.statIdCdStatus)
                      //this.isSpinnerUpdateMonitoria = false;
                      this.dialogRef.close(true);

                  }, errorResponse => {
                    this.setSessionExpired(errorResponse);
                    //this.isSpinnerUpdateMonitoria = false;

                  }).catch((retorno:any) => {
                    //this.isSpinnerUpdateMonitoria = false;
                    if(retorno.error.error_description.indexOf("Access token expired")>-1){
                        alert("Sessão Expirada");
                        this.router.navigate(['']);
                      }
                  });

          }, errorResponse => {
                //this.isSpinnerUpdateMonitoria = false;
                this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO GESTOR');

          }).catch((retorno:any) => {

              //this.isSpinnerUpdateMonitoria = false;
              if(retorno.error.error_description.indexOf("Access token expired")>-1){
                  alert("Sessão Expirada");
                  this.router.navigate(['']);
                }

          });
          */

        }

        //this.isSpinnerUpdateMonitoria = false;
        //this.dialogRef.close(true);

        if(tpEntrada == 'btnSalvar'){
          this.sair("As informações da Ficha FORAM SALVAS! Deseja fechar a tela?");
        }

      },
        errorResponse => { //CASO ERRO
          //this.isSpinnerUpdateMonitoria = false;
          this.setSessionExpired(errorResponse) ? true : this.toastr.info('Erro ao salvar monitoria', 'UPDATE MONITORIA');

        }

      );


    }, errorResponse => {
      this.setSessionExpired(errorResponse);

    }).catch((retorno: any) => {
      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });

   

    return isValidado
  }


  verifyUserLogged() {

    const reLogado = this._AESEncryptDecryptService.decrypt(localStorage.getItem('reUser').trim());
    const userAvaliadoId = this.beanMonitoria.userOperador[0].usuaIdCdUsuario;
    const userAvaliadoRe = this.beanMonitoria.userOperador[0].usuaDsRe;
    const idMonitoria = this.beanMonitoria.moniIdCdMonitoria;


    // 1. VERIFICAR SE O USUÁRIO LOGADO É O USUARIO AVALIADO
    if (reLogado.trim() != userAvaliadoRe.trim()) {

      if (this.atualizarMonitoriaEnviandoBeanCompleto('clickFeedback')) {

        //salvar monitoria antes de abrir a tela de monitoria
        //this.atualizarMonitoriaEnviandoBeanCompleto();

        // 2. SOLICITAR ASSINATURA
        const dialogRef = this.dialog.open(FeedbackLoginDialogDialog, {
          width: '450px',
          height: '560px',
          data: {
            userAvaliadoId: userAvaliadoId,
            userAvaliadoRe: userAvaliadoRe,
            idMonitoria: idMonitoria,
            lastRegularAppraiser: this.getLastRegularAppraiser().user.usuaIdCdUsuario
          }
        });

        dialogRef.afterClosed().subscribe(
          (res) => {
            if (res != undefined) {
              this.formularioMonitoria.controls['txFeedback'].setValue(res.moniTxFeedbackAssinado);

              this.beanMonitoria.moniDhFeedbackAvaliado = res.moniDhFeedbackAvaliado;
              this.beanMonitoria.usuaIdCdUsuarioFeedback = res.usuaIdCdUsuarioFeedback;

              if (res.moniTxFeedbackAssinado != undefined && res.moniTxFeedbackAssinado != '') {
                this.desabilitarTudo()
                this.listarStatusMonitory(this.beanMonitoria.moniIdCdMonitoria);
              }

            }
          }
        );

        return this.isReadOnlyFeedback = true;
      }

    } else {

      if (this.validaStatusAguardandoFeedback()) {
        this.toastr.warning("Status atual é Aguardando Feedback!", "Último STATUS!!")

        return this.isReadOnlyFeedback = true;
      }

      if (this.validaStatusAvaliadorRegular()) {
        this.toastr.warning("Status atual é Aguardando avaliador regular!", "Último STATUS!!")

        return this.isReadOnlyFeedback = true;
      }

      return this.isReadOnlyFeedback = false;
    }

  }




  /**METODO QUE SALVA O CABEÇALHO (INSERE/ALTERA A TABELA PAMO)*/
  salvarParametrosMonitoria(idParametroComMotivo: number) {

    let lstParametros: BeanMonitoryParameter[] = [];

    //VALIDAR SE O PARAMETRO POSSUI VINCULO CADASTRAL DE MOTIVO SE TIVER PRECISA GRAVAR ANTES DE ABRIR A TELA DE VINCULO
    let bean = this.beanFormulario.parameters.filter(bean => Number(bean.paraIdCdParametro) == idParametroComMotivo)[0]

    if (bean != null) {

      //salvar somente os parametros que possuam motivo... ao abrir tela de vinculo de motivos na pamo
      if (bean.beanParametroXMotivo.length > 0) {

        let formControl = this.formCabecalho.controls[bean.paraIdCdParametro];

        if (formControl != undefined && formControl != null) {

          let idNgtbParametroMonitoria = Number(formControl.value.substring(0, formControl.value.indexOf(":")));

          //So salvar se for == 0
          if (idNgtbParametroMonitoria == 0) {
            let beanFormulario: BeanMonitoryParameter = new BeanMonitoryParameter(idNgtbParametroMonitoria,
              Number(this.beanMonitoria.moniIdCdMonitoria),
              idParametroComMotivo,
              '-',
              null,
              null,
              null);

            lstParametros.push(beanFormulario)
          }

        }

      }

    } else {

      for (const campoDoCabecalho in this.formCabecalho.controls) {

        const control = this.formCabecalho.get(campoDoCabecalho);

        let idNgtbParametroMonitoria = Number(campoDoCabecalho.substring(0, campoDoCabecalho.indexOf(":")));
        let idCdtbParametro = Number(campoDoCabecalho.substring(campoDoCabecalho.indexOf(":") + 1, campoDoCabecalho.length));

        if (idNgtbParametroMonitoria > 0 || control.value != '') {

          let beanFormulario: BeanMonitoryParameter = new BeanMonitoryParameter(idNgtbParametroMonitoria,
            Number(this.beanMonitoria.moniIdCdMonitoria),
            idCdtbParametro,
            control.value,
            null,
            null,
            null);
          lstParametros.push(beanFormulario)

        }

      }

    }





    if (lstParametros.length > 0) {

      let listBeanParameters = this.monitoriaService.createUpdateMonitoriaParametros(lstParametros);

      //CORREÇÃO DE DUPLICIDADE DE CABEÇALHOS NO BANCO
      this.monitoriaService.carregaMonitoria(Number(this.beanMonitoria.moniIdCdMonitoria), this.idUsuarioLogado, this.tipoUsuarioLogado)
        .then((retorno: any) => {

          this.beanMonitoria = retorno
          this.montarCamposDaFichaDinamicos();

        }, errorResponse => {

          if (errorResponse.status == 404) {

            this.toastr.info(errorResponse.error.message);

          } else {

            this.toastr.error('Erro conexao backend\nContate o suporte.', 'CARREGAR MONITORIA');

          }

          this.setSessionExpired(errorResponse)

        }).catch((retorno: any) => {

          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }


        });





      return listBeanParameters;
    }



  }



  createUpdateMonitoria(lstParametros: BeanMonitoryParameter[] = []) {

    return this.monitoriaService.createUpdateMonitoriaParametros(lstParametros).then((retorno: BeanMonitoryParameter[]) => {

    },
      errorResponse => { //CASO ERRO
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Perfis disponíveis', 'Lista Perfil');

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });
  }

  gerarTagueamento() {

    if (this.formIdFormularioDisabled == "none" && this.beanMonitoria.moniIdCdMonitoria != "") {

      if (this.beanMonitoria.userOperador[0].usuaDsLoginDac == "") {
        this.toastr.info("O operador avaliado não possui Login Dac", 'Tagueamento');

      } else if (this.tipoLigacao == undefined) {
        this.toastr.info("O Tipo de ligação não foi selecionado", 'Tagueamento');
        return;
      }
      else {

        this.monitoriaService.buscarExportacao(this.beanMonitoria.operIdCdOperacao, this.beanMonitoria.userOperador[0].usuaDsLoginDac, this.tipoLigacao).then((retorno: any) => {

          if (retorno == null) {

            this.toastr.info("Nenhuma ligação encontrada!", 'Tagueamento');
            return;
          }

          this.mogrDsInum = retorno.expoDsInum;
          this.necessarioStatus = true; 
        },
          errorResponse => { //CASO ERRO

            this.setSessionExpired(errorResponse) ? true : this.toastr.error(errorResponse.error.message, 'Tagueamento');

          }).catch((retorno: any) => {

            if (retorno.error.error_description.indexOf("Access token expired") > -1) {
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
          });
      }

    }
  }

  preencheLstRegularAppraiser() {

    this.monitoriaService.getRegularAppraiserByMonitory(this.beanMonitoria.moniIdCdMonitoria).toPromise().then((retorno: BeanRegularAppraiser[]) => {

      this.lstRegularAppraiser = retorno;
      this.beanMonitoria.lstRegularAppraiser = this.lstRegularAppraiser;
    },
      errorResponse => { //CASO ERRO

        this.setSessionExpired(errorResponse) ? true : this.toastr.error(errorResponse.error.message, 'Regular Appraiser');

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {

          alert("Sessão Expirada");
          this.router.navigate(['']);
        }

      });
  }

  getLastRegularAppraiser() {

    return this.lstRegularAppraiser[0];
  }


  openDialogExclusaoMonitoria() {

    const idUsuarioSolicitacao = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());
    const idMonitoria = this.beanMonitoria.moniIdCdMonitoria;

    const dialogRef = this.dialog.open(ExclusaoMonitoriaDialogComponent, {
      width: '450px',
      height: '430px',
      data: {
        idUsuarioSolicitacao: idUsuarioSolicitacao,
        idMonitoria: idMonitoria
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      
      if (result){
        //2024-10-31 DANILLO COSTA - AO EXCLUIR NÃO PEDIR STATUS AO SALVAR E SAIR
        this.necessarioStatus = false;
        this.dialogRef.close();
      }
      
    });

    


  }

  salvarRegularAppraiser() {

    this.monitoriaService.createRegularAppraiser(new BeanRegularAppraiserREQ(Number(this.beanMonitoria.moniIdCdMonitoria), this.idUsuario)).then((retorno: BeanRegularAppraiser) => {

      this.preencheLstRegularAppraiser();
    },
      errorResponse => { //CASO ERRO

        this.setSessionExpired(errorResponse) ? true : this.toastr.error(errorResponse.error.message, 'Regular Appraiser');

      }).catch((retorno: any) => {

        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });
  }


}

@Component({
  selector: 'contestacaoMonitoria',
  templateUrl: 'dialogContestacaoDaPergunta.component.html',
  styleUrls: ['./monitoria.component.css']

})
export class ContestacaoMonitoriaDialog implements OnInit {


  public beanContestation: BeanContestation = new BeanContestation(null, null, null, null, null, null, null, null, null, null);
  public lstBeanContestation: BeanContestation[] = []

  public isAddContestacao: boolean = false;
  public base64Output: string;

  //public anexoSpinner: Boolean = false;
  public contemAnexo: Boolean = false;
  public file: File = null;

  idUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim());
  tipoUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idTipoUsuario")).trim());
  moniDhFeedbackAvaliado: string;
  idStatusMonitoriaAdicionado: number;

  @Input()
  requiredFileType: string;

  fileName = '';
  uploadProgress: number;
  uploadSub: Subscription;
  public statusDaContestacaoSuperior: string = "";


  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ContestacaoMonitoriaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      mqa: BeanMonitoryQuestionAnswer,
      permParaComentar: boolean,
      isCommented: boolean,

    },
    private cadastroUsuarioService: CadastroUsuarioService,
    private configuracaoService: ConfiguracaoService,
    private statusMonitoryService: StatusMonitoryService,

    private monitoriaService: MonitoriaService,
    private userService: CadastroUsuarioService,
    private toastr: ToastrService,
    private router: Router,
    private _AESEncryptDecryptService: AESEncryptDecryptService
  ) {

    this.setFormContested(data);
  }

  selectedIndex: number = 0;
  public idFormulario: string = "";
  public reEdicao: string = "";
  public nomeEdicao: string = "";
  public sessionExpired: boolean = false;

  ngAfterContentChecked() {

    this.resetSessionExpired();
  }

  public setSessionExpired(errorResponse: any) {

    if (errorResponse.status == 401) {

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired() {

    if (this.sessionExpired) {

      this.sessionExpired = false;

      setTimeout(() => this.dialogRef.close({ sessionExpired: true }));
    }
  }


  ngOnInit(): void {

    if (this.data.mqa.contestations != null && this.data.mqa.contestations.length > 0) {
      this.statusDaContestacaoSuperior = this.data.mqa.contestations[0].contInProcedente == 'S' ? "PROCEDENTE" :
        this.data.mqa.contestations[0].contInProcedente == 'N' ? "IMPROCEDENTE" :
          "";

    }

  }

  public formContested: FormGroup = new FormGroup({
    'recmNrSequencia': new FormControl(""),
    'pergDsPergunta': new FormControl(""),
    'respDsResposta': new FormControl(""),
    'usuaIdCdUsuario': new FormControl(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim()),
    'usuaNmUsuario': new FormControl(this._AESEncryptDecryptService.decrypt(localStorage.getItem("nmUser")).trim()),
    'contTxContextacao': new FormControl("")
  })


  showNewContestacao() {

    if (!this.isAddContestacao) {
      this.isAddContestacao = true

    } else {
      this.isAddContestacao = false
    }

  }

  cancelNewContestacao() {
    this.isAddContestacao = false
  }

  showNewResposta(contIdCdContestacao: number, index: number, ultimaRespostaContestacao: string) {
    this.loadDialogRespostaContestacao(contIdCdContestacao, index, ultimaRespostaContestacao)
  }




  salvarContestacao(idPerguntaXResposta: number) {

    if (this.formContested.value.contTxContextacao == "") {
      this.toastr.error('Necessário incluir o texto da contestação', 'CONTESTAÇÃO');
      return
    }

    let idMonitoria = this.data.mqa.moniIdCdMonitoria
    let texto = this.formContested.value.contTxContextacao
    let idUsuario = this.formContested.value.usuaIdCdUsuario

    //let newBean   :  BeanContestation = new BeanContestation( null , idPerguntaXResposta , texto , null , idUsuario , null , null )

    this.beanContestation.permNrSequencia = idPerguntaXResposta;
    this.beanContestation.contTxContestacao = texto;
    this.beanContestation.usuaIdCdUsuario = idUsuario;


    this.monitoriaService.addContestacaoMonitoria(this.beanContestation).then((retorno: BeanContestation) => {


      //atualizar bean de usuario criou a contestação
      this.userService.getUsuarioPorId(retorno.usuaIdCdUsuario).then((retorno2: BeanUsuario) => {
        retorno.userContestacao = retorno2

        this.formContested.controls.contTxContextacao.setValue("");
        this.cancelNewContestacao();

        this.data.mqa.contestations.push(retorno);
        this.data.mqa.contestations[0].contestationAnswers = []

        this.toastr.success('Salvo com sucesso.', 'CONTESTAÇÃO');

        this.dialogRef.close(this.data);


      }, errorResponse => {

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao retornar dados do usuario.', 'RESPOSTA DA CONTESTAÇÃO');
      }).catch((retorno: any) => {
        if (retorno.error.error_description.indexOf("Access token expired") > -1) {
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
      });



      /* this.configuracaoService.getConfiguracaoByChave("grupoconfig.status.contestacao").then((retorno:BeanConfiguracao)=>{

               let beanStatusMonitoryInicial : BeanStatusMonitory = new BeanStatusMonitory();

                 beanStatusMonitoryInicial.statIdCdStatus = retorno.confDsValString
                 beanStatusMonitoryInicial.moniIdCdMonitoria = this.data.mqa.moniIdCdMonitoria;
                 beanStatusMonitoryInicial.usuaIdCdUsuario = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());

                 //GERAR O STATUS
                 this.statusMonitoryService.addStatusMonitory(beanStatusMonitoryInicial).then((retorno:BeanStatusMonitory)=>{
                     this.idStatusMonitoriaAdicionado = Number(beanStatusMonitoryInicial.statIdCdStatus)

                 }, errorresponse => {
                 }).catch((retorno:any) => {
                   if(retorno.error.error_description.indexOf("Access token expired")>-1){
                       alert("Sessão Expirada");
                       this.router.navigate(['']);
                     }
                 });



       }, errorresponse => {
             this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO GESTOR');

       }).catch((retorno:any) => {

           if(retorno.error.error_description.indexOf("Access token expired")>-1){
               alert("Sessão Expirada");
               this.router.navigate(['']);
             }

       });*/







    }, errorResponse => {
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao gravar contestação.', 'CONTESTAÇÃO');

    }).catch((retorno: any) => {

      if (retorno.error.error_description.indexOf("Access token expired") > -1) {
        alert("Sessão Expirada");
        this.router.navigate(['']);
      }
    });

  }



  loadDialogRespostaContestacao(contIdCdContestacao: number, index: number, ultimaRespostaContestacao: string) {

    const dialogRef = this.dialog.open(RespostaComentarioDialog, {
      width: '40%', 
      height: '660px',
      data: this.data
    });

    dialogRef.componentInstance.contIdCdContestacao = contIdCdContestacao;
    dialogRef.componentInstance.ultimaRespostaContestacao = ultimaRespostaContestacao;

    dialogRef.afterClosed().subscribe(result => {
      
      if (result != null && result != undefined && result != true) {

        if (this.data.mqa.contestations[index].contestationAnswers == null) {
          this.data.mqa.contestations[index].contestationAnswers = []
        }

        if (result.sessionExpired) {

          this.sessionExpired = result.sessionExpired;
          this.resetSessionExpired();

        } else {

          if (this.data.mqa.contestations[index].contestationAnswers == null) {
            this.data.mqa.contestations[index].contestationAnswers = []
          }

          this.data.mqa.contestations[index].contestationAnswers.push(result);
          // console.log(this.data.mqa.contestations[index].contestationAnswers.length)
          // console.log(this.data.mqa.contestations[index].contestationAnswers)
          this.statusDaContestacaoSuperior = this.data.mqa.contestations[index].contestationAnswers[this.data.mqa.contestations[index].contestationAnswers.length - 1].recoInProcedente == 'S' ? 'PROCEDENTE' : 'IMPROCEDENTE';

          this.dialogRef.close(this.data.mqa);
        }
      }
    });

  }



  setFormContested(data: { mqa: BeanMonitoryQuestionAnswer, permParaComentar: boolean }) {

    //preenche a descrição da pergunta
    this.monitoriaService.getPergunta(data.mqa.pergIdCdPergunta).then((retorno) => {
      this.formContested.controls.pergDsPergunta.setValue(retorno.pergDsPergunta);
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

    //preenche a descrição da resposta
    this.monitoriaService.getResposta(data.mqa.respIdCdResposta).then((retorno) => {
      this.formContested.controls.respDsResposta.setValue(retorno.respDsResposta);
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

  }


  //seta o arquivo no bean de create contastation
  onFileSelectedContestacao(event, fileUpload) {

    //this.anexoSpinner = true;
    this.file = event.target.files[0];

    if (this.file) {

      this.fileName = this.file.name;

      this.convertFile(this.file).subscribe(base64 => {

        //preencher o arquivo no Bean de contestacao
        this.beanContestation.contDsArquivo = base64
        this.beanContestation.contDsNomeArquivo = this.file.name

        this.base64Output = base64;


      });

    }
  }



  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }


  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }


  downloadAnexoContestacao() {
    //this.anexoSpinner = true
    this.monitoriaService.downloadAnexoContestacao(this.beanContestation.contIdCdContestacao)
      .then((ret) => {

        const downloadLink = document.createElement('a');

        downloadLink.href = 'data:application/octet-stream;base64,' + ret.contDsArquivo;
        downloadLink.download = ret.contDsNomeArquivo;
        downloadLink.click();
        //this.anexoSpinner = false

      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })

  }


  downloadAnexosDaContestacao(arquivo: string, nomeArquivo: string) {

    if (nomeArquivo == '' || nomeArquivo == null) {
      return
    }

    //this.anexoSpinner = true
    const downloadLink = document.createElement('a');
    downloadLink.href = 'data:application/octet-stream;base64,' + arquivo;
    downloadLink.download = nomeArquivo;
    downloadLink.click();
    //this.anexoSpinner = false

  }

  deletarAnexo() {

    this.toastr.success('Arquivo excluido com sucesso!')
    //this.anexoSpinner = false
    this.contemAnexo = false
    this.fileName = ''
    this.file = null
    this.beanContestation.contDsArquivo = null
    this.beanContestation.contDsNomeArquivo = null

  }

}



@Component({
  selector: 'comentarioMonitoria',
  templateUrl: 'dialogComentariosDaPergunta.component.html',
  styleUrls: ['./monitoria.component.css']

})
export class ComentarioMonitoriaDialog implements OnInit {
  clicked = false;
  selectedIndex: number = 0;
  public idFormulario: string = "";
  public reEdicao: string = "";
  public nomeEdicao: string = "";
  public beanMonitoryCommentReply: BeanMonitoryCommentReply = new BeanMonitoryCommentReply();
  idUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim());
  tipoUsuarioLogado: number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idTipoUsuario")).trim());
  moniDhFeedbackAvaliado: string;
  public sessionExpired: boolean = false;
  adicionouComentario : boolean = false; 

  constructor(
    public dialogRef: MatDialogRef<ComentarioMonitoriaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      mqa: BeanMonitoryQuestionAnswer,
      permParaComentar: boolean,
      isCommented: boolean,
      idRespSelecionado: number
    },
    private cadastroUsuarioService: CadastroUsuarioService,
    private monitoriaService: MonitoriaService,
    private toastr: ToastrService,
    private router: Router,
    private _AESEncryptDecryptService: AESEncryptDecryptService
  ) {

    this.beanMonitoryCommentReply.moniIdCdMonitoria = data.mqa.moniIdCdMonitoria;
    this.beanMonitoryCommentReply.grcaIdCdGrupoCategoria = data.mqa.grcaIdCdGrupoCategoria;
    this.beanMonitoryCommentReply.cateIdCdCategoria = data.mqa.cateIdCdCategoria;
    this.beanMonitoryCommentReply.pergIdCdPergunta = data.mqa.pergIdCdPergunta;
    this.beanMonitoryCommentReply.respIdCdResposta = data.idRespSelecionado != undefined ? data.idRespSelecionado : data.mqa.respIdCdResposta;

    this.setFormComment(data);
  }

  ngAfterContentChecked() {

    this.resetSessionExpired();
  }

  public setSessionExpired(errorResponse: any) {

    if (errorResponse.status == 401) {

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired() {

    if (this.sessionExpired) {

      this.sessionExpired = false;

      setTimeout(() => this.dialogRef.close({ sessionExpired: true }));
    }
  }

  ngOnInit(): void {

  }

  
  onNoClick(): void {
    let data = {
      recmTxComentario: this.formComment.value.recmTxComentario,
      adicionouComentario: this.adicionouComentario
    };
    this.dialogRef.close(data);

  }

  public formComment: FormGroup = new FormGroup({
    'recmNrSequencia': new FormControl(""),
    'pergDsPergunta': new FormControl(""),
    'respDsResposta': new FormControl(""),
    'usuaIdCdUsuario': new FormControl(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim()),
    'usuaNmUsuario': new FormControl(this._AESEncryptDecryptService.decrypt(localStorage.getItem("nmUser")).trim()),
    'recmTxComentario': new FormControl("")
  })

  setFormComment(data: { mqa: BeanMonitoryQuestionAnswer, permParaComentar: boolean, idRespSelecionado: number }) {

    this.monitoriaService.getPergunta(data.mqa.pergIdCdPergunta).then((retorno) => {

      this.formComment.controls.pergDsPergunta.setValue(retorno.pergDsPergunta);
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

    this.monitoriaService.getResposta(data.idRespSelecionado != undefined ? data.idRespSelecionado : data.mqa.respIdCdResposta).then((retorno) => {

      this.formComment.controls.respDsResposta.setValue(retorno.respDsResposta);
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })



    if (data.mqa.comment.moniIdCdMonitoria != null && data.mqa.comment.moniIdCdMonitoria != undefined) {

      data.permParaComentar ? this.toastr.warning('Comentario em edição', 'MODO EDIÇÃO') : this.toastr.info('Você não tem permissão para alterar o comentário!');
      this.formComment.controls.recmTxComentario.setValue(data.mqa.comment.recmTxComentario);
      this.formComment.controls.recmNrSequencia.setValue(data.mqa.comment.recmNrSequencia);

      this.monitoriaService.getPessoa(data.mqa.comment.usuaIdCdUsuario).then((retorno) => {
        this.formComment.controls.usuaNmUsuario.setValue(retorno.usuaNmUsuario);

      },
        errorResponse => {

          this.setSessionExpired(errorResponse) ? true : this.toastr.error(errorResponse.error.message, 'Não encontrado o usuário do comentário anterior');
        }).catch((retorno: any) => {

          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
        });

    } else {
      data.permParaComentar ? null : this.toastr.info('Você não tem permissão para adicionar um comentário!');
    }

    if (this.setSessionExpired) {

      return;
    }

  }

  public criarComment() {

    this.clicked = true;

    if (this.formComment.value.recmTxComentario == "") {
      this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
      return
    }

    this.beanMonitoryCommentReply.usuaIdCdUsuario = this.formComment.value.usuaIdCdUsuario;
    this.beanMonitoryCommentReply.recmTxComentario = this.formComment.value.recmTxComentario;


    if (this.formComment.value.recmNrSequencia != "" && this.formComment.value.recmNrSequencia > 0) {

      this.beanMonitoryCommentReply.recmNrSequencia = this.formComment.value.recmNrSequencia;

      this.monitoriaService.updateComentario(this.beanMonitoryCommentReply).then(() => {

        this.data.mqa.comment = this.beanMonitoryCommentReply;
        this.data.isCommented = true;
        this.dialogRef.close(this.data);

        this.adicionouComentario = true;

        this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR');
                
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })

    } else {

      this.monitoriaService.addComentario(this.beanMonitoryCommentReply).then((retorno) => {

        this.data.mqa.comment = retorno;
        this.data.isCommented = true;
        this.dialogRef.close(this.data);
        
        this.adicionouComentario = true;

        this.toastr.success(' Inserido com sucesso', 'SUCESSO AO GRAVAR');
      },
        errorResponse => {
          this.setSessionExpired(errorResponse) ? true : this.toastr.error(' Erro ao gravar comentário', 'ERRO AO GRAVAR');

        }).catch((retorno: any) => {

          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
        });
    }

  }

  //dataSourceFicha = new MatTableDataSource<BeanUsuario>(this.lstUsuarios);
  displayedColumnsBusca: string[] = ['fichaMonitoria', 'inativoFicha'];


  public add(): void {

  }





}



@Component({
  selector: 'observacaoMonitoria',
  templateUrl: 'dialogObservacaoDaPergunta.component.html',
  styleUrls: ['./monitoria.component.css']

})
export class ObservacaoMonitoriaDialog implements OnInit {

  pergDsObservacao: string

  constructor(
    public dialogRef: MatDialogRef<ObservacaoMonitoriaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      pergDsObservacao: string
    },
    private cadastroUsuarioService: CadastroUsuarioService,
    private monitoriaService: MonitoriaService,
    private toastr: ToastrService,
    private router: Router,
    private _AESEncryptDecryptService: AESEncryptDecryptService
  ) {

    this.pergDsObservacao = data.pergDsObservacao;
  }

  ngOnInit(): void {

    this.formObs.get("pergDsObservacao").setValue(this.pergDsObservacao);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public formObs: FormGroup = new FormGroup({
    'pergDsObservacao': new FormControl(""),
  })

}
